import store from "../controller/baseController";
import Enums from "../enums/enums";
import peakUtility from "../function/peakUtility";
import dateTimeHelper from "../helper/dateTimeHelper";
import transactionItemHelper from "../helper/transactionItemHelper";
import i18n from "../locales/i18n";
import journalHelper from "./journalHelper";
import merchantHelper from "./merchantHelper";
import paymentHelper from "./paymentHelper";
import shareHelper from "./shareHelper";
import transactionCreateAndEditHelper from "./transactionCreateAndEditHelper";

function SetPageNo(transactionBaseList, pageSize) {
  let itemIndexTotal = 0;
  let pageNo = 1;
  transactionBaseList.forEach((transactionBase, index) => {
    transactionBase.transactionIndex = index;
    itemIndexTotal += transactionBase.transactionItemList.length;
    if (itemIndexTotal >= pageSize) {
      itemIndexTotal = 0;
      transactionBase.pageNo = pageNo++;
    } else {
      transactionBase.pageNo = pageNo;
    }
  });
}
function SetPageNoImportJournal(journalBaseList, pageSize) {
  let itemIndexTotal = 0;
  let pageNo = 1;
  journalBaseList.forEach((journalItemBase, index) => {
    journalItemBase.transactionIndex = index;
    itemIndexTotal += journalItemBase.journalItemList.length;
    if (itemIndexTotal >= pageSize) {
      itemIndexTotal = 0;
      journalItemBase.pageNo = pageNo++;
    } else {
      journalItemBase.pageNo = pageNo;
    }
  });
}
function SetTransactionBaseModelList(transactionTypeModel, merchantSetting) {
  let transactionBaseList = [];
  let baseTransaction = transactionCreateAndEditHelper.CreateModel(
    Enums.DocumentType.Create,
    transactionTypeModel.transactionType,
    transactionTypeModel.financeType,
    transactionTypeModel.expenseType
  );
  if (
    transactionTypeModel.transactionType == Enums.TransactionType.Invoice &&
    transactionTypeModel.financeType == Enums.FinanceType.OutFlow
  ) {
    baseTransaction.receivedTaxInvoice.value.push({
      receivedTaxInvoiceNumber: null,
      receivedTaxInvoiceDate: null,
      receivedTaxInvoiceJournalDate: null,
    });
  }
  if (
    (transactionTypeModel.transactionType == Enums.TransactionType.Invoice &&
      transactionTypeModel.financeType == Enums.FinanceType.InFlow) ||
    transactionTypeModel.transactionType == Enums.TransactionType.Receipt
  ) {
    if (merchantSetting.isVat) {
      baseTransaction.issueTaxInvoice.value = true;
    }
  }
  baseTransaction.pageNo = 1;
  transactionBaseList = SetDefaultTransactionBaseModelList(baseTransaction);
  return transactionBaseList;
}
function SetTransactionJournalBaseModelList(transactionTypeModel, allocationList) {
  let transactionBaseList = [];
  let baseTransaction = journalHelper.GetCreateJournal(Enums.DocumentType.Create, allocationList);
  baseTransaction.pageNo = 1;
  baseTransaction.isValidateError = true;
  transactionBaseList = SetDefaultTransactionBaseModelList(baseTransaction);
  return transactionBaseList;
}
function SetDefaultTransactionBaseModelList(baseTransaction) {
  let transactionBaseList = [];
  for (let index = 0; index < 5; index++) {
    transactionBaseList.push({ ...baseTransaction, transactionIndex: index });
  }
  return transactionBaseList;
}
function GetTransactionBaseModelList(
  transactionImportList,
  transactionTypeModel,
  pageSize,
  contactList,
  productList,
  accountList,
  bankAccountList,
  merchantSetting,
  allocationItemList
) {
  let transactionBaseList = [];
  transactionImportList.forEach((transactionImport, index) => {
    let transactionModel = GetTransactionBaseModel(
      transactionImport,
      transactionTypeModel,
      contactList,
      productList,
      accountList,
      bankAccountList,
      merchantSetting,
      allocationItemList
    );
    transactionBaseList.push(transactionModel);
  });
  SetPageNo(transactionBaseList, pageSize);
  return transactionBaseList;
}
function GetTransactionReceiptFromInvoiceBaseModelList(
  transactionImportList,
  transactionTypeModel,
  pageSize,
  contactList,
  productList,
  accountList,
  bankAccountList,
  invoiceList,
  merchantSetting,
  importTransactionType
) {
  let transactionBaseList = [];
  transactionImportList.forEach((transactionImport, index) => {
    let transactionModel = GetTransactionReceiptFromInvoiceBaseModel(
      transactionImport,
      transactionTypeModel,
      contactList,
      productList,
      accountList,
      bankAccountList,
      invoiceList,
      merchantSetting,
      importTransactionType
    );
    transactionBaseList.push(transactionModel);
  });
  SetPageNo(transactionBaseList, pageSize);
  return transactionBaseList;
}
function GetTransactionJournalBaseModelList(
  transactionImportList,
  pageSize,
  contactList,
  accountList,
  bankAccountList,
  productList,
  chequeList,
  allocationItemList
) {
  let journalBaseList = [];
  transactionImportList.forEach((transactionImport, index) => {
    let transactionModel = GetTransactionJournalBaseModel(
      transactionImport,
      contactList,
      accountList,
      bankAccountList,
      productList,
      chequeList,
      allocationItemList
    );
    transactionModel.isValidateError = true;
    journalBaseList.push(transactionModel);
  });
  SetPageNoImportJournal(journalBaseList, pageSize);
  return journalBaseList;
}
function GetTransactionBaseModelListByApplyAll(
  transactionBaseList,
  transactionTypeModel,
  applyAllTemplate,
  bankAccountList,
  merchantSetting,
  contactList
) {
  let transactionBaseResultList = [];
  transactionBaseList.forEach((transactionImport, index) => {
    let transactionModel = GetTransactionBaseModelByApplyAll(
      transactionImport,
      transactionTypeModel,
      applyAllTemplate,
      bankAccountList,
      merchantSetting,
      contactList
    );
    transactionBaseResultList.push(transactionModel);
  });
  return transactionBaseResultList;
}
function GetTransactionBaseModel(
  transactionImport,
  transactionTypeModel,
  contactList,
  productList,
  accountList,
  bankAccountList,
  merchantSetting,
  allocationItemList
) {
  let baseTransaction = transactionCreateAndEditHelper.CreateModel(
    Enums.DocumentType.Edit,
    transactionTypeModel.transactionType,
    transactionTypeModel.financeType,
    transactionTypeModel.expenseType
  );
  baseTransaction.number.value = transactionImport.number;
  baseTransaction.date.value =
    transactionImport.issueDate && !isNaN(new Date(transactionImport.issueDate.ToDateJsonString()))
      ? new Date(transactionImport.issueDate).ToDateJsonString()
      : null;
  baseTransaction.issueTaxInvoice.value = transactionImport.isTaxInvoice;
  baseTransaction.reference.referenceName = transactionImport.reference;
  baseTransaction.remark.text = transactionImport.remark;
  if (transactionImport.priceTaxType !== undefined) {
    baseTransaction.taxStatus.value = transactionImport.priceTaxType;
    baseTransaction.taxStatus.isNotAuto = true;
  }
  if (!merchantSetting.isVat && transactionTypeModel.financeType == Enums.FinanceType.InFlow) {
    baseTransaction.taxStatus.value = Enums.TaxTypeId.None;
  }
  if (baseTransaction.taxStatus.value == Enums.TaxTypeId.None) {
    baseTransaction.issueTaxInvoice.value = false;
  }
  if (transactionImport.contact) {
    let selectContactItem;
    if (contactList && contactList.length > 0) {
      if (transactionImport.contact.contactId > 0) {
        selectContactItem = contactList.find((x) => x.id === transactionImport.contact.contactId);
      } else if (transactionImport.contact.code && transactionImport.contact.code.length !== 0) {
        selectContactItem = contactList.find((x) => x.contactCode === transactionImport.contact.code);
      } else if (transactionImport.contact.taxId && transactionImport.contact.taxId.length !== 0) {
        selectContactItem = contactList.find(
          (x) =>
            x.contactTaxId === transactionImport.contact.taxId &&
            x.contactBranchCode === transactionImport.contact.branchCode
        );
        if (!selectContactItem) {
          selectContactItem = contactList.find((x) => x.contactTaxId === transactionImport.contact.taxId);
        }
      }
    }
    baseTransaction.contact = SelectedContact(baseTransaction.contact, selectContactItem);
  }

  if (transactionImport.allocation && transactionImport.allocation.length > 0) {
    transactionImport.allocation.forEach((item) => {
      const allocationItem = allocationItemList.find((x) => x.number === item.allocationNumber);
      if (allocationItem) {
        baseTransaction.allocationTransactionList = [shareHelper.NewObject(allocationItem)];
      }
    });
  }

  if (baseTransaction.dueDate) {
    let defaultDayDueDate = dateTimeHelper.GetDefaultDayDueDateForTransaction();
    let dueDateSetting = dateTimeHelper.GetDueDateFromSetting(
      merchantSetting.settingTransactionDueDate,
      baseTransaction.contact,
      transactionTypeModel
    );
    if (dueDateSetting.isDueDateSetting == true) {
      baseTransaction.dueDate.value = dateTimeHelper.SetDueDate(
        baseTransaction.date.value,
        dueDateSetting.dueDateType,
        dueDateSetting.day
      );
    } else {
      baseTransaction.dueDate.value = dateTimeHelper.SetDueDate(
        baseTransaction.date.value,
        Enums.DueDateSettingType.None,
        defaultDayDueDate
      );
    }
  }
  if (
    transactionTypeModel.transactionType == Enums.TransactionType.Invoice &&
    transactionTypeModel.financeType == Enums.FinanceType.OutFlow
  ) {
    baseTransaction.receivedTaxInvoice.value.push({
      receivedTaxInvoiceNumber: transactionImport.purchaseTaxInvoiceNumber,
      receivedTaxInvoiceDate: transactionImport.purchaseTaxInvoiceDate
        ? new Date(transactionImport.purchaseTaxInvoiceDate)
        : null,
      receivedTaxInvoiceJournalDate: transactionImport.purchaseTaxInvoiceDate
        ? new Date(transactionImport.purchaseTaxInvoiceDate)
        : null,
    });
  }

  if (transactionImport.productItem) {
    baseTransaction.transactionItemList = GetTransactionItemBaseModelList(
      transactionImport.productItem,
      transactionTypeModel,
      productList,
      accountList,
      baseTransaction.taxStatus
    );
  }

  transactionItemHelper.SetTransactionSummary(baseTransaction);
  transactionItemHelper.SetIssueTaxInvoiceForImport(baseTransaction, merchantSetting);

  if (transactionTypeModel.transactionType != Enums.TransactionType.Quotation) {
    if (transactionImport.payment) {
      baseTransaction.payment = GetTransactionPaymentModel(
        baseTransaction,
        transactionImport.payment,
        bankAccountList,
        transactionTypeModel.transactionType,
        accountList
      );
    }
  }

  return baseTransaction;
}
function GetTransactionReceiptFromInvoiceBaseModel(
  transactionImport,
  transactionTypeModel,
  contactList,
  productList,
  accountList,
  bankAccountList,
  invoiceList,
  merchantSetting,
  importTransactionType
) {
  let paymentAmount = 0;
  if (transactionImport.payment) {
    paymentAmount = transactionImport.payment.paymentAmount;
  }

  let baseTransaction = GetTransactionBaseModel(
    transactionImport,
    transactionTypeModel,
    contactList,
    productList,
    accountList,
    bankAccountList,
    merchantSetting,
    importTransactionType
  );

  if (transactionImport.referenceInvoice) {
    if (
      (transactionImport.referenceInvoice.invoiceId > 0 || transactionImport.referenceInvoice.invoiceNumber !== "") &&
      (importTransactionType === Enums.ImportTransactionType.ReceiptFromInvoice ||
        importTransactionType === Enums.ImportTransactionType.ReceiptFromQuotation ||
        importTransactionType === Enums.ImportTransactionType.InvoiceFromQuotation)
    ) {
      transactionImport.payment.paymentAmount = paymentAmount;
      baseTransaction = GetTransationReferenceBaseModel(
        baseTransaction,
        transactionImport,
        invoiceList,
        contactList,
        merchantSetting.canCreateTaxInvoiceNotVat
      );
    }
  }

  return baseTransaction;
}
function GetTransactionJournalBaseModel(
  transactionImport,
  contactList,
  accountList,
  bankAccountList,
  productList,
  chequeList,
  allocationItemList
) {
  let baseTransaction = {
    journalItemList: [],
    date: {
      value:
        transactionImport.issueDate && !isNaN(new Date(transactionImport.issueDate.ToDateJsonString()))
          ? new Date(transactionImport.issueDate).ToDateJsonString()
          : null,
      validateError: false,
    },
    number: {
      text: "",
      validateError: false,
    },
    type: {
      value: transactionImport.journalType,
      name: "",
    },
    reference: {
      text: transactionImport.reference,
    },
    description: {
      text: transactionImport.note,
      validateError: false,
    },
    contact: {
      value: transactionImport.contact.contactId,
    },
    debit: {
      value: 0,
    },
    credit: {
      value: 0,
    },
    allocationTransactionList: transactionItemHelper.SetCreateAllocationTransaction(allocationItemList),
    journalValidate: {
      accountNotInput: {
        row: [],
        validateError: false,
      },
      recordDebitCreditAmount: {
        row: [],
        validateError: false,
      },
      diffDebitCreditAlert: {
        validateError: false,
      },
      accountToShouldSelect: {
        row: [],
        validateError: false,
      },
      journalRevenueDocumentSelectExpenseAccount: {
        row: [],
        validateError: false,
      },
      journalExpenseDocumentSelectRevenueAccount: {
        row: [],
        validateError: false,
      },
      journalRevenueDocumentNotSelectRevenueAccount: {
        validateError: false,
      },
      journalExpenseDocumentSelectExpenseAccount: {
        validateError: false,
      },
      journalDocumentNotSelectPaymentAccount: {
        validateError: false,
      },
    },
  };
  if (
    transactionImport.contact &&
    (transactionImport.contact.contactId >= 0 || transactionImport.contact.code.length !== 0)
  ) {
    let selectContactItem;
    if (contactList && contactList.length > 0) {
      if (transactionImport.contact.contactId > 0) {
        selectContactItem = contactList.find((x) => x.id === transactionImport.contact.contactId);
      } else if (transactionImport.contact.code && transactionImport.contact.code.length !== 0) {
        selectContactItem = contactList.find((x) => x.contactCode === transactionImport.contact.code);
      }
    }
    baseTransaction.contact = SelectedContact(baseTransaction.contact, selectContactItem);
    baseTransaction.contact.value = selectContactItem ? selectContactItem.id : 0;
  }
  if (transactionImport.entityItem) {
    baseTransaction.journalItemList = GetTransactionJournalItemBaseModelList(
      transactionImport.entityItem,
      accountList,
      bankAccountList,
      contactList,
      productList,
      chequeList
    );
  }
  if (transactionImport.allocation && transactionImport.allocation.length > 0) {
    transactionImport.allocation.forEach((item) => {
      const allocationItem = allocationItemList.find((x) => x.number === item.allocationNumber);
      if (allocationItem) {
        baseTransaction.allocationTransactionList = [shareHelper.NewObject(allocationItem)];
      }
    });
  }
  OnChangeImportJournal(baseTransaction);
  return baseTransaction;
}
function GetTransactionBaseModelByApplyAll(
  transactionImport,
  transactionTypeModel,
  applyAllTemplate,
  bankAccountList,
  merchantSetting,
  contactList
) {
  if (applyAllTemplate.issueDate.actived) {
    transactionImport.date.value = applyAllTemplate.issueDate.value;
    if (transactionImport.dueDate) {
      let defaultDayDueDate = dateTimeHelper.GetDefaultDayDueDateForTransaction();
      let dueDateSetting = dateTimeHelper.GetDueDateFromSetting(
        merchantSetting.settingTransactionDueDate,
        transactionImport.contact,
        transactionTypeModel
      );
      if (dueDateSetting.isDueDateSetting == true) {
        transactionImport.dueDate.value = dateTimeHelper.SetDueDate(
          transactionImport.date.value,
          dueDateSetting.dueDateType,
          dueDateSetting.day
        );
      } else {
        transactionImport.dueDate.value = dateTimeHelper.SetDueDate(
          transactionImport.date.value,
          Enums.DueDateSettingType.None,
          defaultDayDueDate
        );
      }
    }
  }
  if (applyAllTemplate.issueTaxInvoice.actived) {
    if (
      transactionImport.transactionSummary.sameProductVatType !== Enums.ProductVatType.None &&
      transactionImport.taxStatus.value !== Enums.TaxTypeId.None &&
      !transactionImport.issueTaxInvoice.disabled
    ) {
      transactionImport.issueTaxInvoice.value = applyAllTemplate.issueTaxInvoice.value;
    }
  }
  if (applyAllTemplate.contact.actived) {
    const selectContactItem = contactList.find((x) => x.id === applyAllTemplate.contact.value.id);
    transactionImport.contact = SelectedContact(transactionImport.contact, selectContactItem);
  }
  if (applyAllTemplate.payment.actived) {
    let paymentMethodSelectItem;
    if (applyAllTemplate.payment.bankAccountId > 0) {
      paymentMethodSelectItem = bankAccountList.find((x) => x.id === applyAllTemplate.payment.bankAccountId);
    }

    transactionImport.payment.paymentGroupList[0].paymentTransactionBankAccountList[0] = SelectedBankAccount(
      transactionImport.payment.paymentGroupList[0].paymentTransactionBankAccountList[0],
      paymentMethodSelectItem
    );
    transactionImport.payment.isValidateError = false;
  }
  if (applyAllTemplate.allocation.actived) {
    if (applyAllTemplate.allocation.allocationItem && applyAllTemplate.allocation.allocationItem.length > 0) {
      transactionImport.allocationTransactionList = applyAllTemplate.allocation.allocationItem;
    }
  }

  return transactionImport;
}
function GetTransactionBaseModelByByAddedFinance(importTransactionItem, bankAccountList, selectedBankAccountId) {
  let paymentSelected;
  if (selectedBankAccountId > 0) {
    paymentSelected = bankAccountList.find((x) => x.id === selectedBankAccountId);
  }
  importTransactionItem.payment.paymentGroupList[0].paymentTransactionBankAccountList[0] = SelectedBankAccount(
    importTransactionItem.payment.paymentGroupList[0].paymentTransactionBankAccountList[0],
    paymentSelected
  );
  return importTransactionItem;
}
function GetTransactionItemBaseModelList(productItemList, transactionTypeModel, productList, accountList, taxStatus) {
  let transactionItemBaseList = [];
  productItemList.forEach((productItem, index) => {
    let transactionImportProductItemModel = GetTransactionItemBaseModel(
      productItem,
      transactionTypeModel,
      productList,
      accountList,
      taxStatus
    );
    transactionItemBaseList.push(transactionImportProductItemModel);
  });
  return transactionItemBaseList;
}
function GetTransactionJournalItemBaseModelList(
  transactionImportEntityItem,
  accountList,
  bankAccountList,
  contactList,
  productList,
  chequeList
) {
  let transactionItemBaseList = [];
  transactionImportEntityItem.forEach((entityItem, index) => {
    let transactionImportJournalItemModel = GetTransactionJournalItemBaseModel(
      entityItem,
      accountList,
      bankAccountList,
      contactList,
      productList,
      chequeList
    );
    transactionItemBaseList.push(transactionImportJournalItemModel);
  });
  return transactionItemBaseList;
}
function GetTransactionItemBaseModel(productItem, transactionTypeModel, productList, accountList, taxStatus) {
  let baseTransactionItem = transactionItemHelper.GetCreateTransactionItemDefualt(
    transactionTypeModel.transactionType,
    transactionTypeModel.financeType,
    transactionTypeModel.expenseType
  );
  baseTransactionItem.description.text = productItem.description != null ? productItem.description : "";
  baseTransactionItem.amount.value = productItem.quantity.ToPeakTransactionItemFormat();
  baseTransactionItem.price.value = productItem.price.ToPeakTransactionItemFormat();
  baseTransactionItem.discount.value = productItem.discount.ToPeakTransactionItemFormat();
  baseTransactionItem.discount.discountTypeId = productItem.discountType;

  if (productItem.vatType === null) {
    baseTransactionItem.vatTypeId.isSuggestion = true;
    baseTransactionItem.itemWht.value = Enums.ProductVatType.SevenPercent;
  } else {
    if (
      transactionTypeModel.financeType == Enums.FinanceType.OutFlow &&
      productItem.vatType == Enums.ProductVatType.ZeroPercent
    ) {
      baseTransactionItem.vatTypeId.value = Enums.ProductVatType.SevenPercent;
    } else {
      baseTransactionItem.vatTypeId.value = productItem.vatType;
    }
  }
  if (taxStatus.value == Enums.TaxTypeId.None) {
    baseTransactionItem.vatTypeId.value = Enums.ProductVatType.None;
  }

  baseTransactionItem.itemWht.whtAmountType = productItem.whtType;
  baseTransactionItem.itemWht.value = productItem.wht;

  baseTransactionItem.account.isNotAuto =
    (baseTransactionItem.description.text != null && baseTransactionItem.description.text != "") ||
    productItem.accountId == 0 ||
    (productItem.accountCode != null && productItem.accountCode != "");

  if (
    !(
      transactionTypeModel.transactionType == Enums.TransactionType.Invoice &&
      transactionTypeModel.financeType == Enums.FinanceType.OutFlow &&
      transactionTypeModel.expenseType == Enums.ExpenseType.Expense
    )
  ) {
    baseTransactionItem.productTemplate.isNotAuto =
      (baseTransactionItem.description.text != null && baseTransactionItem.description.text != "") ||
      productItem.productTemplate.productId != 0 ||
      (productItem.productTemplate.code != null && productItem.productTemplate.code != "");
    if (productItem.productTemplate) {
      let selectProductTemplateItem;
      if (productList && productList.length > 0) {
        if (productItem.productTemplate.productId > 0) {
          selectProductTemplateItem = productList.find((x) => x.id === productItem.productTemplate.productId);
        } else if (productItem.productTemplate.code && productItem.productTemplate.code.length !== 0) {
          selectProductTemplateItem = productList.find((x) => x.code === productItem.productTemplate.code);
        }
      }
      baseTransactionItem = SelectedProductTransaction(
        baseTransactionItem,
        selectProductTemplateItem,
        transactionTypeModel.transactionType,
        transactionTypeModel.financeType,
        taxStatus
      );
    }
  }
  let selectAccountItem;
  if (accountList && accountList.length > 0) {
    if (productItem.accountId && productItem.accountId > 0) {
      selectAccountItem = accountList.find((x) => x.id === productItem.accountId);
    } else if (productItem.accountCode && productItem.accountCode.length !== 0) {
      selectAccountItem = accountList.find((x) => x.code === productItem.accountCode);
    }
    if (!selectAccountItem) {
      if (baseTransactionItem.account.id > 0) {
        selectAccountItem = accountList.find((x) => x.id === baseTransactionItem.account.id);
      }
    }
  }
  baseTransactionItem = SelectedAccount(
    baseTransactionItem,
    selectAccountItem,
    transactionTypeModel.transactionType,
    transactionTypeModel.financeType
  );

  return baseTransactionItem;
}
function GetTransactionJournalItemBaseModel(
  entityItem,
  accountList,
  bankAccountList,
  contactList,
  productList,
  chequeList
) {
  let baseTransactionItem = {
    account: {
      id: entityItem.accountId,
      code: entityItem.accountCode,
      name: "",
      nameEng: "",
      referenceTypeId: 0,
    },
    subAccount: {
      code: entityItem.accountSubCode,
      name: "",
      referenceId: entityItem.accountSubId,
      referenceTypeId: entityItem.accountSubCodeType,
    },
    description: {
      text: entityItem.description ? entityItem.description : "",
    },
    debit: {
      value: entityItem.debit.FormatMoney(),
    },
    credit: {
      value: entityItem.credit.FormatMoney(),
    },
    stockActivityId: 0,
  };
  if (accountList && accountList.length > 0) {
    let selectedAccount;
    if (entityItem.accountId >= 0 && entityItem.accountCode && entityItem.accountCode.length !== 0) {
      selectedAccount = accountList.find((x) => x.code == entityItem.accountCode);
      if (selectedAccount) {
        baseTransactionItem.account.id = selectedAccount.id;
        baseTransactionItem.account.code = selectedAccount.code;
        baseTransactionItem.account.name = selectedAccount.name.locale;
        baseTransactionItem.account.referenceTypeId = selectedAccount.referenceTypeId;
      }
    }
  }

  let selectedSubAccount;
  let subAccountFullName;
  let subAccountCode;
  if (entityItem.accountSubCode && entityItem.accountSubCode.length !== 0) {
    switch (baseTransactionItem.account.referenceTypeId) {
      case Enums.JournalAccountReferenceType.BankAccount:
        let bankAccountListForSelectSubAccount = journalHelper.GetBankAccountListForSelectSubAccount(
          baseTransactionItem.account.code,
          bankAccountList
        );
        selectedSubAccount = bankAccountListForSelectSubAccount.find((x) => {
          let pathAccountSubCode = x.code.split(" ");
          let index = pathAccountSubCode.findIndex((item) => item !== "");
          if (pathAccountSubCode[index] === entityItem.accountSubCode) {
            return x;
          }
        });
        if (selectedSubAccount) {
          subAccountFullName = ` - ${selectedSubAccount.code} - ${selectedSubAccount.fullName}`;
          subAccountCode = selectedSubAccount.code;
        }
        break;
      case Enums.JournalAccountReferenceType.Cheque:
        selectedSubAccount = chequeList.find((x) => x.chequeCode === entityItem.accountSubCode);
        if (selectedSubAccount) {
          subAccountFullName = ` - ${selectedSubAccount.chequeCode} - ${selectedSubAccount.chequeNumber}`;
          subAccountCode = selectedSubAccount.chequeCode;
        }
        break;
      case Enums.JournalAccountReferenceType.Contact:
        selectedSubAccount = contactList.find((x) => x.contactCode === entityItem.accountSubCode);
        if (selectedSubAccount) {
          subAccountFullName = ` - ${selectedSubAccount.contactCode} - ${selectedSubAccount.contactFullName}`;
          subAccountCode = selectedSubAccount.contactCode;
        }
        break;
      case Enums.JournalAccountReferenceType.ProductTemplate:
        selectedSubAccount = productList.find((x) => (x.code ? x.code.trim() : "") === entityItem.accountSubCode);
        if (selectedSubAccount) {
          subAccountFullName = ` - ${selectedSubAccount.code} - ${selectedSubAccount.name}`;
          subAccountCode = selectedSubAccount.code;
        }
        break;
    }
  }
  if (selectedSubAccount) {
    baseTransactionItem.subAccount.referenceId = selectedSubAccount.id;
    baseTransactionItem.subAccount.name = subAccountFullName;
    baseTransactionItem.subAccount.code = subAccountCode;
  } else {
    baseTransactionItem.subAccount.code = "";
  }

  baseTransactionItem.subAccount.referenceTypeId = baseTransactionItem.account.referenceTypeId;

  if (baseTransactionItem.description.text === "") {
    baseTransactionItem.description.text = baseTransactionItem.account.name + baseTransactionItem.subAccount.name;
  }
  return baseTransactionItem;
}
function GetTransactionPaymentModel(transaction, paymentItem, bankAccountList, transactionType, accountList) {
  let accountListForMap = shareHelper.GetAccountListForMap(accountList);
  let transactionSummary = transaction.transactionSummary;
  let baseTransactionPayment = paymentHelper.GetCreateTransactionPaymentDefualt();
  let basePaymentGroup = baseTransactionPayment.paymentGroupList[0];
  basePaymentGroup.paymentGroupDate = transaction.date.value;
  let basePaymentTransactionBankAccount = basePaymentGroup.paymentTransactionBankAccountList[0];

  let selectBankAccountItem;
  if (bankAccountList && bankAccountList.length > 0) {
    if (paymentItem.paymentMethod.paymentMethodId > 0) {
      selectBankAccountItem = bankAccountList.find((x) => x.id === paymentItem.paymentMethod.paymentMethodId);
    } else if (paymentItem.paymentMethod.code && paymentItem.paymentMethod.code.length !== 0) {
      selectBankAccountItem = bankAccountList.find((x) => x.code === paymentItem.paymentMethod.code);
      if (!selectBankAccountItem) {
        selectBankAccountItem = bankAccountList.find(
          (x) =>
            (x.code ? x.code.trim() : "") ===
            (paymentItem.paymentMethod.code ? paymentItem.paymentMethod.code.trim() : "")
        );
      }
    }
  }
  basePaymentTransactionBankAccount = SelectedBankAccount(basePaymentTransactionBankAccount, selectBankAccountItem);

  if (transactionType === Enums.TransactionType.Receipt) {
    paymentItem.paymentAmount = peakUtility.PeakOperatorSubtract(
      transactionSummary.netAmount.ToNumber(),
      paymentItem.wht.ToNumber()
    );
  }
  if (paymentItem.paymentAmount > 0) {
    let paymentAmountWithWht = peakUtility
      .PeakOperatorAdd(paymentItem.paymentAmount, paymentItem.wht)
      .ToAccountingRoundUp();
    let paymentRatio =
      transactionSummary.netAmount.ToNumber() >= paymentAmountWithWht.ToNumber()
        ? peakUtility.PeakOperatorDivide(paymentAmountWithWht, transactionSummary.netAmount)
        : 0;
    let paymentWht = peakUtility
      .PeakOperatorMultiply(paymentRatio, transactionSummary.paymentWht.whtTotal)
      .ToAccountingRoundUp();
    let paymentAmountWithOutWht = peakUtility
      .PeakOperatorSubtract(paymentAmountWithWht, paymentWht)
      .ToPeakTransactionItemFormat();
    basePaymentTransactionBankAccount.paymentAmount = paymentAmountWithOutWht.ToPeakTransactionItemFormat();
    if (!transactionSummary.isNoneOrNotSpecifyWht) {
      basePaymentGroup.whtPayment.isWht = true;
      basePaymentGroup.whtPayment.whtAmount = paymentWht;
      basePaymentGroup.whtPayment.whtAmountTypeId = paymentHelper.GetWhtPaymentPercent(
        transactionSummary.subTotalForCalculateWht,
        paymentWht,
        transactionSummary.netAmount.ToNumber(),
        paymentAmountWithWht.ToNumber()
      );
      paymentHelper.CalculateAllPaymentGroupSummary(baseTransactionPayment);
      if (basePaymentGroup.whtPayment.whtAmountTypeId !== Enums.WhtAmountType.Custom.type) {
        paymentHelper.CalculateWhtAmount(
          transactionSummary.netAmount.ToNumber(),
          transactionSummary.subTotalForCalculateWht,
          basePaymentGroup
        );
      }
      basePaymentGroup.whtPayment.pndTypeId = paymentItem.pndType;
      let isOrdinaryPerson = merchantHelper.IsOrdinaryPerson(transaction.contact.contactType);
      if (
        basePaymentGroup.whtPayment.pndTypeId == Enums.PndType.None ||
        (isOrdinaryPerson && basePaymentGroup.whtPayment.pndTypeId == Enums.PndType.PND53) ||
        (!isOrdinaryPerson && basePaymentGroup.whtPayment.pndTypeId != Enums.PndType.PND53)
      ) {
        basePaymentGroup.whtPayment.pndTypeId = paymentHelper.GetSuggestionPndType(transaction, accountListForMap);
      }
    } else {
      paymentHelper.CalculateAllPaymentGroupSummary(baseTransactionPayment);
      basePaymentGroup.whtPayment.whtAmountTypeId = Enums.WhtAmountType.Custom.type;
      basePaymentGroup.whtPayment.whtAmount = "0.00";
    }
  }
  paymentHelper.CalculateAllPaymentGroupSummary(baseTransactionPayment);

  return baseTransactionPayment;
}
function GetTransationReferenceBaseModel(
  baseTransaction,
  transactionImport,
  invoiceList,
  contactList,
  canCreateTaxInvoiceNotVat
) {
  let selectedInvoice;
  if (transactionImport.referenceInvoice.invoiceId > 0) {
    selectedInvoice = invoiceList.find((x) => x.id === transactionImport.referenceInvoice.invoiceId);
  } else if (transactionImport.referenceInvoice.invoiceNumber !== "") {
    selectedInvoice = invoiceList.find((x) => x.invoiceNumber === transactionImport.referenceInvoice.invoiceNumber);
  }

  let transaction = baseTransaction;
  if (selectedInvoice) {
    let paymentAmount = transactionImport.payment.paymentAmount + transactionImport.payment.wht;
    let remainPaymentAmount = selectedInvoice.transactionSummaryModel.remainPaymentNetAmount.ToNumber();
    let remainWhtAmount = selectedInvoice.transactionSummaryModel.remainWhtPaymentNetAmount.ToNumber();
    let paymentRatio =
      remainPaymentAmount.ToNumber() >= paymentAmount
        ? peakUtility.PeakOperatorDivide(paymentAmount, remainPaymentAmount)
        : 0;
    let paymentWhtAmount = peakUtility.PeakOperatorMultiply(paymentRatio, remainWhtAmount).ToAccountingRoundUp();
    let paymentNetAmount = peakUtility.PeakOperatorSubtract(paymentAmount, paymentWhtAmount).ToAccountingRoundUp();

    OnChangeImportTransactionReceiptFromInvoice(
      transaction,
      selectedInvoice,
      paymentNetAmount,
      paymentWhtAmount,
      transaction.date.value,
      contactList,
      canCreateTaxInvoiceNotVat
    );
  }

  return transaction;
}
function GetTransactionCreateModelList(transactionList, transactionTypeModel, importTransactionType) {
  let transactionImportList = [];
  transactionList.forEach((transaction, index) => {
    let transactionImport = GetTransactionCreateModel(transaction, transactionTypeModel, importTransactionType);
    transactionImportList.push(transactionImport);
  });

  return transactionImportList;
}
function GetTransactionCreateFromReferenceModelList(transactionList, transactionTypeModel, importTransactionType) {
  let transactionImportList = [];
  transactionList.forEach((transaction, index) => {
    let transactionImport = GetTransactionCreateFromReferenceModel(
      transaction,
      transactionTypeModel,
      importTransactionType
    );
    transactionImportList.push(transactionImport);
  });

  return transactionImportList;
}
function GetTransactionCreateJournalModelList(transactionList) {
  let transactionImportList = [];
  transactionList.forEach((transaction, index) => {
    let transactionImport = GetTransactionCreateJournalModel(transaction);
    transactionImportList.push(transactionImport);
  });

  return transactionImportList;
}
function GetTransactionCreateModel(transaction, transactionTypeModel, importTransactionType) {
  let transactionImport = {
    number: transaction.number.value,
    issueDate: transaction.date.value,
    dueDate: transaction.dueDate.value,
    isTaxInvoice: transaction.issueTaxInvoice.value,
    priceTaxType: transaction.taxStatus.value,
    reference: transaction.reference.referenceName,
    remark: transaction.remark.text,
    purchaseTaxInvoiceNumber: transaction.receivedTaxInvoice
      ? transaction.receivedTaxInvoice.value[0].receivedTaxInvoiceNumber
      : null,
    purchaseTaxInvoiceDate: transaction.receivedTaxInvoice
      ? transaction.receivedTaxInvoice.value[0].receivedTaxInvoiceDate
      : null,
    contact: {
      contactId: transaction.contact.id,
      code: transaction.contact.contactCode,
      name: transaction.contact.contactFullName,
      taxId: transaction.contact.taxId,
      branchCode: transaction.contact.contactBranchCode,
      contactWhtType: transaction.contact.contactWhtType,
    },
    productItem: GetTransactionItemCreateModelList(transaction.transactionItemList, transactionTypeModel),
    payment:
      transaction.payment &&
      transaction.payment.paymentGroupList[0].isPaymentActive &&
      transactionTypeModel.transactionType != Enums.TransactionType.Quotation
        ? {
            paymentMethod: {
              paymentMethodId: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0]
                .bankAccountId
                ? transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountId
                : 0,
              code: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountCode,
              name: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountName,
            },
            paymentAmount: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].paymentAmount,
            wht: transaction.payment.paymentGroupList[0].whtPayment.whtAmount
              ? transaction.payment.paymentGroupList[0].whtPayment.whtAmount.ToAccountingRoundUpNumber()
              : 0,
            whtType: transaction.payment.paymentGroupList[0].whtPayment.whtAmountTypeId,
            pndType: transaction.payment.paymentGroupList[0].whtPayment.pndTypeId,
          }
        : null,
    allocation: GetAllocationTransactionList(transaction.allocationTransactionList),
  };
  return transactionImport;
}
function GetTransactionCreateFromReferenceModel(transaction, transactionTypeModel, importTransactionType) {
  let transactionImport = {
    number: transaction.number.value,
    issueDate: transaction.date.value,
    dueDate: transaction.dueDate.value,
    isTaxInvoice: transaction.issueTaxInvoice.value,
    referenceInvoice: {
      invoiceId: transaction.reference.referenceId,
      invoiceNumber: transaction.reference.referenceName,
      contact: {
        contactId: transaction.contact.id,
        code: transaction.contact.contactCode,
        name: transaction.contact.contactFullName,
        taxId: transaction.contact.taxId,
        branchCode: transaction.contact.contactBranchCode,
      },
      summary: {
        subTotal:
          transaction.transactionSummary.vat.preVatTotal.ToNumber() +
          transaction.transactionSummary.vatExemptedTotal.ToNumber() +
          transaction.transactionSummary.zeroVatTotal.ToNumber(),
        netAmount: transaction.transactionSummary.netAmount.ToNumber(),
        whtTotal: transaction.transactionSummary.paymentWht.whtTotal.ToNumber(),
        vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
        zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
        preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
        subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
      },
    },
    remark: transaction.remark.text,
    payment:
      transaction.payment &&
      transaction.payment.paymentGroupList[0].isPaymentActive &&
      transactionTypeModel.transactionType != Enums.TransactionType.Quotation
        ? {
            paymentMethod: {
              paymentMethodId: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0]
                .bankAccountId
                ? transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountId
                : 0,
              code: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountCode,
              name: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].bankAccountName,
            },
            paymentAmount: transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].paymentAmount,
            wht: transaction.payment.paymentGroupList[0].whtPayment.whtAmount
              ? transaction.payment.paymentGroupList[0].whtPayment.whtAmount.ToAccountingRoundUpNumber()
              : 0,
            whtType: transaction.payment.paymentGroupList[0].whtPayment.whtAmountTypeId,
            pndType: transaction.payment.paymentGroupList[0].whtPayment.pndTypeId,
          }
        : null,
  };

  return transactionImport;
}
function GetTransactionCreateJournalModel(transaction) {
  let transactionImport = {
    journalType: transaction.type.value,
    issueDate: transaction.date.value,
    reference: transaction.reference.text,
    contact: {
      contactId: transaction.contact.value,
    },
    allocation: GetAllocationTransactionList(transaction.allocationTransactionList),
    note: transaction.description.text,
    entityItem: [],
  };
  if (transaction.journalItemList) {
    for (let journalItem of transaction.journalItemList) {
      transactionImport.entityItem.push({
        accountId: journalItem.account.id,
        accountCode: journalItem.account.code,
        description: journalItem.description.text,
        accountSubId: journalItem.subAccount.referenceId,
        accountSubCode: journalItem.subAccount.code,
        debit: journalItem.debit.value,
        credit: journalItem.credit.value,
        accountSubCodeType: journalItem.account.referenceTypeId,
      });
    }
  }
  return transactionImport;
}
function GetTransactionItemCreateModelList(transactionItemList, transactionTypeModel) {
  let productItemList = [];
  transactionItemList.forEach((transactionItem, index) => {
    let productItem = GetTransactionItemCreateModel(transactionItem, transactionTypeModel);
    productItemList.push(productItem);
  });
  return productItemList;
}
function GetAllocationTransactionList(allocationTransactionList) {
  let allocation = [];
  if (allocationTransactionList && allocationTransactionList.length > 0) {
    allocationTransactionList.forEach((item) => {
      allocation.push({
        allocationId: item.allocationId,
        allocationNumber: item.number,
        allocationItem: [{ allocationItemId: item.id }],
      });
    });
  }
  return allocation;
}
function GetTransactionItemCreateModel(transactionItem, transactionTypeModel) {
  let productItem = {
    productTemplate: !(
      transactionTypeModel.transactionType == Enums.TransactionType.Invoice &&
      transactionTypeModel.financeType == Enums.FinanceType.OutFlow &&
      transactionTypeModel.expenseType == Enums.ExpenseType.Expense
    )
      ? {
          productId: transactionItem.productTemplate.id,
          code: transactionItem.productTemplate.code,
          name: transactionItem.productTemplate.name,
        }
      : null,
    accountId: transactionItem.account.id ? transactionItem.account.id : 0,
    accountCode: transactionItem.account.code,
    description: transactionItem.description.text,
    quantity: transactionItem.amount.value,
    price: transactionItem.price.value,
    discount: transactionItem.discount.value,
    discountType: transactionItem.discount.discountTypeId,
    netAmount: transactionItem.itemPreVatTotal,
    vatType: transactionItem.vatTypeId.value,
    wht: transactionItem.itemWht.value,
    whtType: transactionItem.itemWht.whtAmountType,
  };
  return productItem;
}
function OnChangeImportTransaction(transactionBase, transactionTypeModel) {
  transactionItemHelper.SetTransactionSummary(transactionBase);
  if (transactionTypeModel.transactionType != Enums.TransactionType.Quotation) {
    paymentHelper.CalculateAllPaymentGroupSummary(transactionBase.payment);
    if (!transactionBase.transactionSummary.isNoneOrNotSpecifyWht) {
      transactionBase.payment.paymentGroupList[0].whtPayment.isWht = true;
      transactionBase.payment.paymentGroupList[0].whtPayment.whtAmountTypeId = paymentHelper.GetWhtPaymentPercent(
        transactionBase.transactionSummary.subTotalForCalculateWht,
        transactionBase.payment.paymentGroupList[0].whtPayment.whtAmount,
        transactionBase.transactionSummary.netAmount,
        transactionBase.payment.paymentGroupList[0].paymentGroupTotal
      );
      if (transactionBase.payment.paymentGroupList[0].whtPayment.whtAmountTypeId !== Enums.WhtAmountType.Custom.type) {
        paymentHelper.CalculateWhtAmount(
          transactionBase.transactionSummary.netAmount.ToNumber(),
          transactionBase.transactionSummary.subTotalForCalculateWht,
          transactionBase.payment.paymentGroupList[0]
        );
      }
    } else {
      transactionBase.payment.paymentGroupList[0].whtPayment.whtAmountTypeId = Enums.WhtAmountType.Custom.type;
      transactionBase.payment.paymentGroupList[0].whtPayment.whtAmount = "0.00";
    }
    paymentHelper.CalculateAllPaymentGroupSummary(transactionBase.payment);
  }
  transactionItemHelper.CheckErrorValueInput(transactionBase, true);
}
function OnChangeImportJournal(journalBase) {
  journalHelper.CalculateJournal(journalBase);
  journalHelper.ValidateJournal(journalBase);
}
function OnChangeImportTransactionReceiptFromInvoice(
  transactionBase,
  selectedInvoice,
  paymentNetAmount,
  paymentWhtAmount,
  issueDate,
  contactList,
  canCreateTaxInvoiceNotVat
) {
  transactionBase.reference.referenceId = selectedInvoice.id;
  transactionBase.reference.referenceName = selectedInvoice.invoiceNumber;
  transactionBase.contact.id = selectedInvoice.contactId;
  transactionBase.date.value = issueDate;
  transactionBase.transactionSummary.netAmount =
    selectedInvoice.transactionSummaryModel.remainPaymentNetAmount.FormatMoney();
  transactionBase.transactionSummary.remainPaymentNetAmount =
    selectedInvoice.transactionSummaryModel.remainPaymentNetAmount.FormatMoney();

  transactionBase.payment.paymentAllGroupTotal = peakUtility.PeakOperatorAdd(paymentNetAmount, paymentWhtAmount);
  transactionBase.transactionSummary.remainWhtPaymentNetAmount =
    selectedInvoice.transactionSummaryModel.remainWhtPaymentNetAmount.ToNumber();
  transactionBase.transactionSummary.paymentWht.whtTotal =
    selectedInvoice.transactionSummaryModel.remainWhtPaymentNetAmount.ToNumber();

  transactionBase.payment.paymentGroupList[0].paymentTransactionBankAccountList[0].paymentAmount =
    paymentNetAmount.FormatMoney();
  transactionBase.payment.paymentGroupList[0].whtPayment.whtAmount =
    paymentWhtAmount > 0 ? paymentWhtAmount.FormatMoney() : "0.00";

  transactionBase.transactionSummary.vat.preVatTotal = selectedInvoice.transactionSummaryModel.preVatTotal;
  transactionBase.transactionSummary.vatExemptedTotal = selectedInvoice.transactionSummaryModel.vatExemptedTotal;
  transactionBase.transactionSummary.zeroVatTotal = selectedInvoice.transactionSummaryModel.zeroVatTotal;
  transactionBase.transactionSummary.vat.vatTotal = selectedInvoice.transactionSummaryModel.vatTotal;
  transactionBase.transactionSummary.subTotal = selectedInvoice.transactionSummaryModel.subTotal;
  transactionBase.transactionSummary.subTotalForCalculateWht =
    selectedInvoice.transactionSummaryModel.subTotalForCalculateWht;
  transactionBase.transactionSummary.sameProductVatType = selectedInvoice.transactionSummaryModel.sameProductVatType;

  if (selectedInvoice.isCreatedTaxInvoice) {
    transactionBase.issueTaxInvoice.value = false;
    transactionBase.issueTaxInvoice.disabled = true;
    transactionBase.issueTaxInvoice.isNotAuto = true;
  } else if (canCreateTaxInvoiceNotVat) {
    transactionBase.issueTaxInvoice.value =
      selectedInvoice.transactionSummaryModel.sameProductVatType !== Enums.ProductVatType.None;
    transactionBase.issueTaxInvoice.disabled = false;
    transactionBase.issueTaxInvoice.isNotAuto = true;
  } else {
    transactionBase.issueTaxInvoice.value =
      selectedInvoice.transactionSummaryModel.sameProductVatType !== Enums.ProductVatType.None;
    transactionBase.issueTaxInvoice.disabled =
      selectedInvoice.transactionSummaryModel.sameProductVatType == Enums.ProductVatType.None;
    transactionBase.issueTaxInvoice.isNotAuto = true;
  }

  let selectedContact = contactList.find((x) => x.id === selectedInvoice.contactId);
  transactionBase.contact = SelectedContact(transactionBase.contact, selectedContact);
}

function GetContactBranchModel() {
  return {
    id: 0,
    name: "",
    branchCode: "",
    address: {
      id: 0,
      contactName: "",
      address: "",
      subDistrict: "",
      district: "",
      province: "",
      country: "",
      road: "",
      building: "",
      postCode: "",
      soi: "",
      floorNo: "",
      roomNo: "",
      homeNo: "",
      homeGroup: "",
    },
  };
}

function GetContactBankModel() {
  return {
    id: 0,
    bankName: "",
    accountNumber: "",
    accountName: "",
    branch: "",
    bankReferenceBankId: null,
  };
}

function GetContactPersonModel() {
  return {
    id: 0,
    firstname: "",
    lastname: "",
    nickname: "",
    position: "",
    personPhone: "",
    personEmail: "",
    isMainPerson: 0,
    isSendEmail: 0,
    personalNamePrefixTypeId: Enums.PrefixNameType.None,
    personalNamePrefixOther: "",
    departmentTypeId: Enums.DepartmentType.None,
    departmentOther: "",
  };
}

function GetCreateContactModel() {
  return {
    id: 0,
    contactFinanceType: Enums.ContactFinanceType.All,
    name: "",
    isVat: 0,
    email: "",
    phone: "",
    address: {
      address: "",
      subDistrict: "",
      district: "",
      province: "",
      country: "",
      road: "",
      building: "",
      postCode: "",
    },
    merchantType: Enums.MerchantType.None,
    contactName: "",
    fax: "",
    website: "",
    code: "",
    invoiceIncomeType: Enums.ContactInvoiceDueDateType.MerchantDefault,
    invoiceIncomeValue: 0,
    accountsReceivableAccountId: 0,
    invoiceExpenseType: Enums.ContactInvoiceDueDateType.MerchantDefault,
    invoiceExpenseValue: 0,
    accountsPayableAccountId: 0,
    personalNamePrefixType: Enums.PrefixNameType.None,
    personalNamePrefixOther: "",
    taxId: "",
    bankInformation: [],
    personToContact: [],
    contactGroupIdList: [],
    contactBranchModel: {
      id: 0,
      name: "",
      branchCode: "",
      address: {
        address: "",
        subDistrict: "",
        district: "",
        province: "",
        country: "",
        road: "",
        building: "",
        postcode: "",
      },
    },
    contactCreditLimit: 0.0,
    creditLimitSettingType: Enums.CreditLimitType.Default,
    invoiceReceiptGoodsReceiptAccountId: 0,
  };
}

function GetCreateContactListInputFromImportContactList(importContactList) {
  const createContactListMap = {};

  for (const importContact of importContactList) {
    let createContact = createContactListMap.hasOwnProperty(importContact.sequenceNumber)
      ? createContactListMap[importContact.sequenceNumber]
      : GetCreateContactModel();

    if (importContact.isPrimary) {
      createContact.sequenceNumber = importContact.sequenceNumber; /* unnecessary input field */
      createContact.id = 0;
      createContact.contactFinanceType = importContact.general.financeType.value.value;
      createContact.name = `${importContact.general.firstName.value} ${importContact.general.lastName.value}`.trim();
      createContact.isVat = 0;
      createContact.email = importContact.contactChannel.email.value;
      createContact.phone = importContact.contactChannel.phone.value;
      createContact.address.address = importContact.officeAddress.address.value;
      createContact.address.subDistrict = importContact.officeAddress.subDistrict.value;
      createContact.address.district = importContact.officeAddress.district.value;
      createContact.address.province = importContact.officeAddress.province.value;
      createContact.address.country = importContact.general.nationalityType.value.nameEn;
      createContact.address.road = null;
      createContact.address.building = null;
      createContact.address.postCode = importContact.officeAddress.postcode.value;
      createContact.merchantType = importContact.general.merchantType.value.value;
      createContact.contactName = importContact.officeAddress.contactName.value;
      createContact.fax = importContact.contactChannel.fax.value;
      createContact.website = importContact.contactChannel.website.value;
      createContact.code = importContact.general.code.value;
      createContact.invoiceIncomeType = importContact.dueDateSetting.invoiceDueDateType.value.value;
      createContact.invoiceIncomeValue = importContact.dueDateSetting.invoiceDueDate.value.ToNumber();
      createContact.accountsReceivableAccountId = importContact.accountRecord.receivableAccount.value.id;
      createContact.invoiceExpenseType = importContact.dueDateSetting.expenseDueDateType.value.value;
      createContact.invoiceExpenseValue = importContact.dueDateSetting.expenseDueDate.value.ToNumber();
      createContact.accountsPayableAccountId = importContact.accountRecord.payableAccount.value.id;
      createContact.personalNamePrefixType = importContact.general.prefixNameType.value.value;
      createContact.taxId = importContact.general.taxId.value;
      createContact.contactBranchModel.id = 0;
      createContact.contactBranchModel.name = importContact.registeredAddress.contactName.value;
      createContact.contactBranchModel.branchCode = importContact.general.branchCode.value;
      createContact.contactBranchModel.address.address = importContact.registeredAddress.address.value;
      createContact.contactBranchModel.address.subDistrict = importContact.registeredAddress.subDistrict.value;
      createContact.contactBranchModel.address.district = importContact.registeredAddress.district.value;
      createContact.contactBranchModel.address.province = importContact.registeredAddress.province.value;
      createContact.contactBranchModel.address.country = importContact.general.nationalityType.value.nameEn;
      createContact.contactBranchModel.address.road = null;
      createContact.contactBranchModel.address.building = null;
      createContact.contactBranchModel.address.postcode = importContact.registeredAddress.postcode.value;
      createContact.contactCreditLimit = importContact.creditLimit.amount.value.ToNumber();
      createContact.creditLimitSettingType = importContact.creditLimit.creditLimitType.value.value;
      createContact.invoiceReceiptGoodsReceiptAccountId = 219; /* database id of '212305 - ค่าใช้จ่ายค้างจ่ายอื่น' */
      createContact.personToContact = [];
      createContact.contactGroupIdList = [];

      const bank = GetContactBankModel();

      bank.id = 0;
      bank.bankName = importContact.bank.bankReferenceType.value.name;
      bank.accountNumber = importContact.bank.accountNumber.value;
      bank.accountName = importContact.bank.accountName.value;
      bank.branch = importContact.bank.accountBranchNumber.value;
      bank.bankReferenceBankId =
        importContact.bank.bankReferenceType.value.bankReferenceBankId === Enums.BankReferenceType.NONE
          ? null
          : importContact.bank.bankReferenceType.value.bankReferenceBankId;

      createContact.bankInformation = [];
      createContact.bankInformation.push(bank);
    }

    if (importContact.isHaveContactPerson || importContact.isPrimary) {
      let contactPerson = GetContactPersonModel();

      contactPerson.firstname = importContact.contactPerson.firstName.value;
      contactPerson.lastname = importContact.contactPerson.lastName.value;
      contactPerson.nickname = importContact.contactPerson.nickName.value;
      contactPerson.position = importContact.contactPerson.position.value;
      contactPerson.personPhone = importContact.contactPerson.phone.value;
      contactPerson.personEmail = importContact.contactPerson.email.value;
      contactPerson.isMainPerson = importContact.isPrimary ? 1 : 0;
      contactPerson.isSendEmail = 1;
      contactPerson.personalNamePrefixTypeId = importContact.contactPerson.prefixNameType.value.value;
      contactPerson.departmentTypeId = importContact.contactPerson.departmentType.value.value;

      createContact.personToContact.push(contactPerson);
    }

    if (
      importContact.isHaveGroup &&
      !createContact.contactGroupIdList.includes(importContact.group.value.id) &&
      importContact.group.value.id > 0
    ) {
      createContact.contactGroupIdList.push(importContact.group.value.id);
    }

    createContactListMap[importContact.sequenceNumber] = createContact;
  }

  return Object.values(createContactListMap);
}

function GetEditContactListInputFromImportContactList(importContactList, contactDetailListMap) {
  const editContactListMap = {};

  for (const importContact of importContactList) {
    let editContact = editContactListMap.hasOwnProperty(importContact.sequenceNumber)
      ? editContactListMap[importContact.sequenceNumber]
      : contactDetailListMap[importContact.general.code.value];

    if (!editContact || editContact.id === 0) {
      continue;
    }

    if (importContact.isPrimary) {
      editContact.sequenceNumber = importContact.sequenceNumber; /* unnecessary input field */
      editContact.contactFinanceType = importContact.general.financeType.value.value;
      editContact.name = `${importContact.general.firstName.value} ${importContact.general.lastName.value}`.trim();
      editContact.email = importContact.contactChannel.email.value;
      editContact.phone = importContact.contactChannel.phone.value;
      editContact.address.address = importContact.officeAddress.address.value;
      editContact.address.subDistrict = importContact.officeAddress.subDistrict.value;
      editContact.address.district = importContact.officeAddress.district.value;
      editContact.address.province = importContact.officeAddress.province.value;
      editContact.address.country = importContact.general.nationalityType.value.nameEn;
      editContact.address.postCode = importContact.officeAddress.postcode.value;
      editContact.merchantType = importContact.general.merchantType.value.value;
      editContact.contactName = importContact.officeAddress.contactName.value;
      editContact.fax = importContact.contactChannel.fax.value;
      editContact.website = importContact.contactChannel.website.value;
      editContact.code = importContact.general.code.value;
      editContact.invoiceIncomeType = importContact.dueDateSetting.invoiceDueDateType.value.value;
      editContact.invoiceIncomeValue = importContact.dueDateSetting.invoiceDueDate.value.ToNumber();
      editContact.accountsReceivableAccountId = importContact.accountRecord.receivableAccount.value.id;
      editContact.invoiceExpenseType = importContact.dueDateSetting.expenseDueDateType.value.value;
      editContact.invoiceExpenseValue = importContact.dueDateSetting.expenseDueDate.value.ToNumber();
      editContact.accountsPayableAccountId = importContact.accountRecord.payableAccount.value.id;
      editContact.personalNamePrefixType = importContact.general.prefixNameType.value.value;
      editContact.taxId = importContact.general.taxId.value;

      if (!editContact.contactBranchModel) {
        editContact.contactBranchModel = GetContactBranchModel();
      }

      editContact.contactBranchModel.name = importContact.registeredAddress.contactName.value;
      editContact.contactBranchModel.branchCode = importContact.general.branchCode.value;
      editContact.contactBranchModel.address.address = importContact.registeredAddress.address.value;
      editContact.contactBranchModel.address.subDistrict = importContact.registeredAddress.subDistrict.value;
      editContact.contactBranchModel.address.district = importContact.registeredAddress.district.value;
      editContact.contactBranchModel.address.province = importContact.registeredAddress.province.value;
      editContact.contactBranchModel.address.country = importContact.general.nationalityType.value.nameEn;
      editContact.contactBranchModel.address.postcode = importContact.registeredAddress.postcode.value;

      editContact.contactCreditLimit = importContact.creditLimit.amount.value.ToNumber();
      editContact.creditLimitSettingType = importContact.creditLimit.creditLimitType.value.value;
      editContact.personToContact = [];
      editContact.contactGroupIdList = [];

      if (!editContact.bankInformation && editContact.bankInformation.length === 0) {
        editContact.bankInformation = [];
        editContact.bankInformation.push(GetContactBankModel());
      }

      for (const editBank of editContact.bankInformation) {
        editBank.bankName = importContact.bank.bankReferenceType.value.name;
        editBank.accountNumber = importContact.bank.accountNumber.value;
        editBank.accountName = importContact.bank.accountName.value;
        editBank.branch = importContact.bank.accountBranchNumber.value;
        editBank.bankReferenceBankId =
          importContact.bank.bankReferenceType.value.bankReferenceBankId === Enums.BankReferenceType.NONE
            ? null
            : importContact.bank.bankReferenceType.value.bankReferenceBankId;
      }
    }

    if (importContact.isHaveContactPerson || importContact.isPrimary) {
      let contactPerson = GetContactPersonModel();

      contactPerson.firstname = importContact.contactPerson.firstName.value;
      contactPerson.lastname = importContact.contactPerson.lastName.value;
      contactPerson.nickname = importContact.contactPerson.nickName.value;
      contactPerson.position = importContact.contactPerson.position.value;
      contactPerson.personPhone = importContact.contactPerson.phone.value;
      contactPerson.personEmail = importContact.contactPerson.email.value;
      contactPerson.isMainPerson = importContact.isPrimary ? 1 : 0;
      contactPerson.isSendEmail = 1;
      contactPerson.personalNamePrefixTypeId = importContact.contactPerson.prefixNameType.value.value;
      contactPerson.departmentTypeId = importContact.contactPerson.departmentType.value.value;

      editContact.personToContact.push(contactPerson);
    }

    if (importContact.isHaveGroup && !editContact.contactGroupIdList.includes(importContact.group.value.id)) {
      editContact.contactGroupIdList.push(importContact.group.value.id);
    }

    editContactListMap[importContact.sequenceNumber] = editContact;
  }

  return Object.values(editContactListMap);
}

function GetProductBeginningModel() {
  return {
    date: null,
    amount: 0.0,
    cost: 0.0,
  };
}

function GetProductSkuModel() {
  return {
    id: 0,
    productTemplateId: 0,
    skuTemplateId: 0,
    code: "",
  };
}

function GetCreateProductModel() {
  return {
    productTemplate: {
      id: 0,
      productCode: "",
      name: "",
      description: "",
      type: Enums.ProductTemplateType.None,
      purchasePrice: 0.0,
      purchaseVatTypeId: 3,
      purchaseAccountId: 14,
      sellPrice: 0.0,
      sellVatTypeId: Enums.ProductVatType.None,
      sellAccountId: 0,
      costOfGoodsSoldAccountId: 0,
      StockType: Enums.StockType.None,
      isRecordJournalCostOfGoodsSold: true,
      barcode: "",
      startStock: 0.0,
      startPrice: 0.0,
      unit: {
        id: 0,
        nameTh: "",
        nameEng: "",
        unitType: Enums.UnitType.None,
        unitCode: "",
      },
      productImageList: [],
      startStockList: [],
    },
    skuGroupModelList: [],
  };
}

export function GetCreateProductListInputFromImportProductList(importProductList, skuTemplateList, productType) {
  const createProductListMap = {};
  const skuTemplateMapper = {};

  if (productType === Enums.ProductTemplateType.Product) {
    for (const skuTemplate of skuTemplateList) {
      skuTemplateMapper[skuTemplate.skuType] = skuTemplate;
    }
  }

  for (const importProduct of importProductList) {
    let createProduct = createProductListMap.hasOwnProperty(importProduct.sequenceNumber)
      ? createProductListMap[importProduct.sequenceNumber]
      : GetCreateProductModel();

    if (importProduct.isPrimary) {
      createProduct.sequenceNumber = importProduct.sequenceNumber; /* unnecessary input field */
      createProduct.productTemplate.productCode = importProduct.general.code.value;
      createProduct.productTemplate.name = importProduct.general.name.value;
      createProduct.productTemplate.description = importProduct.general.description.value;
      createProduct.productTemplate.type = productType;
      createProduct.productTemplate.purchasePrice = importProduct.purchaseInfo.price.value;
      createProduct.productTemplate.purchaseVatTypeId = importProduct.purchaseInfo.vatType.value.value;
      createProduct.productTemplate.purchaseAccountId = importProduct.accountRecord.purchaseAccount.value.id;
      createProduct.productTemplate.sellPrice = importProduct.sellInfo.price.value;
      createProduct.productTemplate.sellVatTypeId = importProduct.sellInfo.vatType.value.value;
      createProduct.productTemplate.sellAccountId = importProduct.accountRecord.sellAccount.value.id;
      createProduct.productTemplate.unit.id = importProduct.general.unitType.value.id;
      createProduct.productTemplate.unit.nameTh = importProduct.general.unitType.value.nameTh;
      createProduct.productTemplate.unit.nameEng = importProduct.general.unitType.value.nameEng;
      createProduct.productTemplate.unit.unitType = importProduct.general.unitType.value.unitType
        ? importProduct.general.unitType.value.unitType
        : Enums.UnitType.None;
      createProduct.productTemplate.unit.unitCode = importProduct.general.unitType.value.unitCode
        ? importProduct.general.unitType.value.unitCode
        : "";
      createProduct.productTemplate.startStockList = [];
      createProduct.skuGroupModelList = [];

      if (productType === Enums.ProductTemplateType.Product) {
        createProduct.productTemplate.costOfGoodsSoldAccountId = importProduct.costCalculation.costAccount.value.id;
        createProduct.productTemplate.StockType = importProduct.costCalculation.methodType.value.value;
        createProduct.productTemplate.isRecordJournalCostOfGoodsSold =
          importProduct.costCalculation.calculateType.value.value;
        createProduct.productTemplate.barcode = importProduct.sku.barcode.value;

        if (importProduct.sku.shopee.value) {
          const skuTemplateShopee = skuTemplateMapper[Enums.SkuType.Shopee];
          if (skuTemplateShopee && skuTemplateShopee.isActive) {
            const skuShopee = GetProductSkuModel();

            skuShopee.skuTemplateId = skuTemplateShopee.id;
            skuShopee.code = importProduct.sku.shopee.value;

            createProduct.skuGroupModelList.push(skuShopee);
          }
        }

        if (importProduct.sku.lazada.value) {
          const skuTemplateLazada = skuTemplateMapper[Enums.SkuType.Lazada];
          if (skuTemplateLazada && skuTemplateLazada.isActive) {
            const skuLazada = GetProductSkuModel();

            skuLazada.skuTemplateId = skuTemplateLazada.id;
            skuLazada.code = importProduct.sku.lazada.value;

            createProduct.skuGroupModelList.push(skuLazada);
          }
        }

        if (importProduct.sku.tiktok.value) {
          const skuTemplateTiktok = skuTemplateMapper[Enums.SkuType.TikTokShop];
          if (skuTemplateTiktok && skuTemplateTiktok.isActive) {
            const skuTiktok = GetProductSkuModel();

            skuTiktok.skuTemplateId = skuTemplateTiktok.id;
            skuTiktok.code = importProduct.sku.tiktok.value;

            createProduct.skuGroupModelList.push(skuTiktok);
          }
        }
      }
    }

    if (productType === Enums.ProductTemplateType.Product && importProduct.isHaveProductBeginning) {
      const productBeginning = GetProductBeginningModel();

      productBeginning.date = importProduct.productBeginning.date.value;
      productBeginning.amount = importProduct.productBeginning.amount.value;
      productBeginning.cost = importProduct.productBeginning.cost.value;

      createProduct.productTemplate.startStockList.push(productBeginning);
    }

    createProductListMap[importProduct.sequenceNumber] = createProduct;
  }

  return Object.values(createProductListMap);
}

export function GetEditProductListInputFromImportProductList(
  importProductList,
  productTemplateListMap,
  skuTemplateList,
  productType
) {
  let editProductList = [];
  const skuTemplateMapper = {};

  if (productType === Enums.ProductTemplateType.Product) {
    for (const skuTemplate of skuTemplateList) {
      skuTemplateMapper[skuTemplate.skuType] = skuTemplate;
    }
  }

  for (const importProduct of importProductList) {
    const editProduct = productTemplateListMap[importProduct.general.code.value];

    if (!editProduct || editProduct.productTemplate.id === 0) {
      continue;
    }

    editProduct.sequenceNumber = importProduct.sequenceNumber; /* unnecessary input field */

    editProduct.productTemplate.name = importProduct.general.name.value;
    editProduct.productTemplate.description = importProduct.general.description.value;
    editProduct.productTemplate.unit.id = importProduct.general.unitType.value.id;
    editProduct.productTemplate.unit.nameTh = importProduct.general.unitType.value.nameTh;
    editProduct.productTemplate.unit.nameEng = importProduct.general.unitType.value.nameEng;
    editProduct.productTemplate.unit.unitType = importProduct.general.unitType.value.unitType
      ? importProduct.general.unitType.value.unitType
      : Enums.UnitType.None;
    editProduct.productTemplate.unit.unitCode = importProduct.general.unitType.value.unitCode
      ? importProduct.general.unitType.value.unitCode
      : "";

    editProduct.productTemplate.purchasePrice = importProduct.purchaseInfo.price.value;
    editProduct.productTemplate.purchaseVatTypeId = importProduct.purchaseInfo.vatType.value.value;

    editProduct.productTemplate.sellPrice = importProduct.sellInfo.price.value;
    editProduct.productTemplate.sellVatTypeId = importProduct.sellInfo.vatType.value.value;

    if (productType === Enums.ProductTemplateType.Service) {
      editProduct.productTemplate.purchaseAccountId = importProduct.accountRecord.purchaseAccount.value.id;
    }

    editProduct.productTemplate.sellAccountId = importProduct.accountRecord.sellAccount.value.id;

    if (productType === Enums.ProductTemplateType.Product) {
      let newSkuGroupList = [];

      const oldSkuGroupMapper = {};
      for (const skuGroup of editProduct.skuGroupModelList) {
        oldSkuGroupMapper[skuGroup.skuTemplateId] = skuGroup;
      }

      /* if already have SKU group just update code value if not create new SKU group */
      const skuTemplateShopee = skuTemplateMapper[Enums.SkuType.Shopee];
      if (skuTemplateShopee && skuTemplateShopee.isActive) {
        let skuGroupShopee = oldSkuGroupMapper[skuTemplateShopee.id];

        if (!skuGroupShopee) {
          skuGroupShopee = GetProductSkuModel();

          skuGroupShopee.productTemplateId = editProduct.productTemplate.id;
          skuGroupShopee.skuTemplateId = skuTemplateShopee.id;
        }

        skuGroupShopee.code = importProduct.sku.shopee.value;
        newSkuGroupList.push(skuGroupShopee);
      }

      /* if already have SKU group just update code value if not create new SKU group */
      const skuTemplateLazada = skuTemplateMapper[Enums.SkuType.Lazada];
      if (skuTemplateLazada && skuTemplateLazada.isActive) {
        let skuGroupLazada = oldSkuGroupMapper[skuTemplateLazada.id];

        if (!skuGroupLazada) {
          skuGroupLazada = GetProductSkuModel();

          skuGroupLazada.productTemplateId = editProduct.productTemplate.id;
          skuGroupLazada.skuTemplateId = skuTemplateLazada.id;
        }

        skuGroupLazada.code = importProduct.sku.lazada.value;
        newSkuGroupList.push(skuGroupLazada);
      }

      /* if already have SKU group just update code value if not create new SKU group */
      const skuTemplateTikTok = skuTemplateMapper[Enums.SkuType.TikTokShop];
      if (skuTemplateTikTok && skuTemplateTikTok.isActive) {
        let skuGroupTikTok = oldSkuGroupMapper[skuTemplateTikTok.id];

        if (!skuGroupTikTok) {
          skuGroupTikTok = GetProductSkuModel();

          skuGroupTikTok.productTemplateId = editProduct.productTemplate.id;
          skuGroupTikTok.skuTemplateId = skuTemplateTikTok.id;
        }

        skuGroupTikTok.code = importProduct.sku.tiktok.value;
        newSkuGroupList.push(skuGroupTikTok);
      }

      editProduct.skuGroupModelList = newSkuGroupList;
      editProduct.productTemplate.barcode = importProduct.sku.barcode.value;
    }

    editProductList.push(editProduct);
  }

  return editProductList;
}

//#region Header
function SetImportTemplatePurchaseInventoryHeader(isAFPPackage) {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    number: {
      hidden: true,
    },
    reference: {
      class: "left",
      width: 130,
      name: i18n.t("Ref"),
      columnName: "C",
      hidden: false,
      positionTooltip: "right",
      tooltip: i18n.t("Refer_to_placeholder"),
    },
    docDate: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_tooltip"),
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact_Payee"),
      hidden: false,
      columnName: "D,E,F",
      positionTooltip: "right",
      tooltip: i18n.t("Contact_Payee_tooltip"),
    },
    taxInvoice: {
      hidden: true,
    },
    purchaseTaxInvoiceNumber: {
      class: "left",
      width: 130,
      name: i18n.t("Tax_Invoice_Nomber"),
      hidden: false,
      columnName: "G",
      positionTooltip: "right",
      tooltip: i18n.t("Tax_Invoice_Date_tooltip"),
    },
    purchaseTaxInvoiceDate: {
      class: "center",
      width: 130,
      name: i18n.t("Tax_Invoice_Date"),
      hidden: false,
      columnName: "H",
      positionTooltip: "right",
      tooltip: i18n.t("Tax_Invoice_Date_tooltip"),
    },
    pricingType: {
      class: "left",
      width: 140,
      name: i18n.t("Pricing_Type"),
      hidden: false,
      columnName: "I",
      positionTooltip: "right",
      tooltip: [{ content: i18n.t("Pricing_Type_tooltip.first") }, { content: i18n.t("Pricing_Type_tooltip.second") }],
    },
    productTemplate: {
      class: "left",
      width: 200,
      name: i18n.t("Product_Service_For_Expense"),
      hidden: false,
      columnName: "J",
      positionTooltip: "right",
      tooltip: i18n.t("Product_tooltip"),
    },
    accountTemplate: {
      class: "left",
      width: 150,
      name: i18n.t("Expense_Account"),
      hidden: false,
      columnName: "K",
      positionTooltip: "right",
      tooltip: i18n.t("Expense_Account_tooltip"),
    },
    description: {
      class: "left",
      width: 250,
      name: i18n.t("Description"),
      hidden: false,
      columnName: "L",
      positionTooltip: "right",
      tooltip: i18n.t("Description_item_tooltip"),
    },
    quantity: {
      class: "right",
      width: 110,
      name: i18n.t("Quantity"),
      hidden: false,
      columnName: "M",
      positionTooltip: "right",
      tooltip: i18n.t("Quantitye_tooltip"),
    },
    price: {
      class: "right",
      width: 130,
      name: i18n.t("Price"),
      hidden: false,
      columnName: "N",
      positionTooltip: "right",
      tooltip: i18n.t("Price_tooltip"),
    },
    discount: {
      hidden: true,
    },
    preVatAmount: {
      class: "right",
      width: 150,
      name: i18n.t("Pre_VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Pre_VAT_Amount_tooltip.first") },
        { content: i18n.t("Pre_VAT_Amount_tooltip.second") },
      ],
    },
    vatType: {
      class: "left",
      width: 80,
      name: i18n.t("VAT"),
      hidden: false,
      columnName: "O",
      positionTooltip: "right",
      tooltip: i18n.t("VAT_tooltip"),
    },
    vatAmount: {
      class: "right",
      width: 130,
      name: i18n.t("VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [{ content: i18n.t("VAT_Amount_tooltip.first") }, { content: i18n.t("VAT_Amount_tooltip.second") }],
    },
    netAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Net_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: i18n.t("Net_Amount_tooltip"),
    },
    wht: {
      class: "right",
      width: 130,
      name: i18n.t("WHT"),
      hidden: false,
      columnName: "P",
      positionTooltip: "right",
      tooltip: i18n.t("WHT_tooltip"),
    },
    paymentBankAccount: {
      class: "left",
      width: 150,
      name: i18n.t("Paid_via"),
      hidden: false,
      columnName: "Q",
      positionTooltip: "right",
      tooltip: i18n.t("Paid_via_tooltip"),
    },
    paymentAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Payment_amount"),
      hidden: false,
      columnName: "R",
      positionTooltip: "right",
      tooltip: i18n.t("Payment_amount_tooltip"),
    },
    paymentWhtAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Total_WHT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: i18n.t("Total_WHT_Amount"),
    },
    pnd: {
      class: "right",
      width: 100,
      name: i18n.t("PND"),
      hidden: false,
      columnName: "S",
      positionTooltip: "left",
      tooltip: i18n.t("PND_tooltip"),
    },
    remark: {
      class: "left",
      width: 200,
      name: i18n.t("Remark"),
      hidden: false,
      columnName: "T",
      positionTooltip: "left",
      tooltip: i18n.t("Remark_for_customer_placeholder"),
    },
    classification: {
      class: "left",
      width: 160,
      name: i18n.t("Menu_Classification"),
      hidden: isAFPPackage,
      columnName: "U",
      positionTooltip: "left",
      tooltip: i18n.t("Classification_Group_Allocation_Tooltip"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportTemplateExpenseHeader(isAFPPackage) {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    number: {
      hidden: true,
    },
    reference: {
      class: "left",
      width: 130,
      name: i18n.t("Ref"),
      hidden: false,
      columnName: "C",
      positionTooltip: "right",
      tooltip: i18n.t("Refer_to_placeholder"),
    },
    docDate: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_tooltip"),
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact_Payee"),
      hidden: false,
      columnName: "D,E,F",
      positionTooltip: "right",
      tooltip: i18n.t("Contact_Payee_tooltip"),
    },
    taxInvoice: {
      hidden: true,
    },
    purchaseTaxInvoiceNumber: {
      class: "left",
      width: 130,
      name: i18n.t("Tax_Invoice_Nomber"),
      hidden: false,
      columnName: "G",
      positionTooltip: "right",
      tooltip: i18n.t("Tax_Invoice_Date_tooltip"),
    },
    purchaseTaxInvoiceDate: {
      class: "center",
      width: 130,
      name: i18n.t("Tax_Invoice_Date"),
      hidden: false,
      columnName: "H",
      positionTooltip: "right",
      tooltip: i18n.t("Tax_Invoice_Date_tooltip"),
    },
    pricingType: {
      class: "left",
      width: 140,
      name: i18n.t("Pricing_Type"),
      hidden: false,
      columnName: "I",
      positionTooltip: "right",
      tooltip: [{ content: i18n.t("Pricing_Type_tooltip.first") }, { content: i18n.t("Pricing_Type_tooltip.second") }],
    },
    productTemplate: {
      hidden: true,
    },
    accountTemplate: {
      class: "left",
      width: 150,
      name: i18n.t("Expense_Account"),
      hidden: false,
      columnName: "J",
      positionTooltip: "right",
      tooltip: i18n.t("Expense_Account_tooltip"),
    },
    description: {
      class: "left",
      width: 250,
      name: i18n.t("Description"),
      hidden: false,
      columnName: "K",
      positionTooltip: "right",
      tooltip: i18n.t("Description_item_tooltip"),
    },
    quantity: {
      class: "right",
      width: 110,
      name: i18n.t("Quantity"),
      hidden: false,
      columnName: "L",
      positionTooltip: "right",
      tooltip: i18n.t("Quantitye_tooltip"),
    },
    price: {
      class: "right",
      width: 130,
      name: i18n.t("Price"),
      hidden: false,
      columnName: "M",
      positionTooltip: "right",
      tooltip: i18n.t("Price_tooltip"),
    },
    discount: {
      hidden: true,
    },
    preVatAmount: {
      class: "right",
      width: 150,
      name: i18n.t("Pre_VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Pre_VAT_Amount_tooltip.first") },
        { content: i18n.t("Pre_VAT_Amount_tooltip.second") },
      ],
    },
    vatType: {
      class: "left",
      width: 80,
      name: i18n.t("VAT"),
      hidden: false,
      columnName: "N",
      positionTooltip: "right",
      tooltip: i18n.t("VAT_tooltip"),
    },
    vatAmount: {
      class: "right",
      width: 130,
      name: i18n.t("VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [{ content: i18n.t("VAT_Amount_tooltip.first") }, { content: i18n.t("VAT_Amount_tooltip.second") }],
    },
    netAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Net_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: i18n.t("Net_Amount_tooltip"),
    },
    wht: {
      class: "right",
      width: 130,
      name: i18n.t("WHT"),
      hidden: false,
      columnName: "O",
      positionTooltip: "right",
      tooltip: i18n.t("WHT_tooltip"),
    },
    paymentBankAccount: {
      class: "left",
      width: 150,
      name: i18n.t("Paid_via"),
      hidden: false,
      columnName: "P",
      positionTooltip: "right",
      tooltip: i18n.t("Paid_via_tooltip"),
    },
    paymentAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Payment_amount"),
      hidden: false,
      columnName: "Q",
      positionTooltip: "right",
      tooltip: i18n.t("Payment_amount_tooltip"),
    },
    paymentWhtAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Total_WHT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: i18n.t("Total_WHT_Amount"),
    },
    pnd: {
      class: "right",
      width: 100,
      name: i18n.t("PND"),
      hidden: false,
      columnName: "R",
      positionTooltip: "left",
      tooltip: i18n.t("PND_tooltip"),
    },
    remark: {
      class: "left",
      width: 200,
      name: i18n.t("Remark"),
      hidden: false,
      columnName: "S",
      positionTooltip: "left",
      tooltip: i18n.t("Remark_for_customer_placeholder"),
    },
    classification: {
      class: "left",
      width: 160,
      name: i18n.t("Menu_Classification"),
      hidden: isAFPPackage,
      columnName: "T",
      positionTooltip: "left",
      tooltip: i18n.t("Classification_Group_Allocation_Tooltip"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportTemplateInvoiceHeader(isAFPPackage) {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    number: {
      class: "left",
      width: 180,
      hidden: false,
      name: i18n.t("Document_No"),
      placeholder: i18n.t("Document_No_Import_placeholder"),
      columnName: "C",
      positionTooltip: "right",
      tooltip: i18n.t("Document_No_Tooltip"),
    },
    reference: {
      class: "left",
      width: 130,
      name: i18n.t("Ref"),
      hidden: false,
      columnName: "D",
      positionTooltip: "right",
      tooltip: i18n.t("Refer_to_placeholder"),
    },
    docDate: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_tooltip"),
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact_Customer"),
      hidden: false,
      columnName: "E,F,G",
    },
    taxInvoice: {
      class: "left",
      width: 160,
      hidden: false,
      name: i18n.t("Tax_Invoice"),
      columnName: "H",
      positionTooltip: "right",
      tooltip: i18n.t("Tax_Invoice_Import_Tooltip"),
    },
    purchaseTaxInvoiceNumber: {
      hidden: true,
    },
    purchaseTaxInvoiceDate: {
      hidden: true,
    },
    pricingType: {
      class: "left",
      width: 140,
      name: i18n.t("Pricing_Type"),
      hidden: false,
      columnName: "I",
      positionTooltip: "right",
      tooltip: [{ content: i18n.t("Pricing_Type_tooltip.first") }, { content: i18n.t("Pricing_Type_tooltip.second") }],
    },
    productTemplate: {
      class: "left",
      width: 200,
      name: i18n.t("Product_Service_For_Expense"),
      hidden: false,
      columnName: "J",
      positionTooltip: "right",
      tooltip: i18n.t("Product_Service_tooltip_Only"),
    },
    accountTemplate: {
      class: "left",
      width: 150,
      name: i18n.t("Expense_Account"),
      hidden: false,
      columnName: "K",
      positionTooltip: "right",
      tooltip: i18n.t("Expense_Account_tooltip"),
    },
    description: {
      class: "left",
      width: 250,
      name: i18n.t("Description"),
      hidden: false,
      columnName: "L",
      positionTooltip: "right",
      tooltip: i18n.t("Description_item_tooltip"),
    },
    quantity: {
      class: "right",
      width: 110,
      name: i18n.t("Quantity"),
      hidden: false,
      columnName: "M",
      positionTooltip: "right",
      tooltip: i18n.t("Quantitye_tooltip"),
    },
    price: {
      class: "right",
      width: 130,
      name: i18n.t("Price_Per_Unit"),
      hidden: false,
      columnName: "N",
      positionTooltip: "right",
      tooltip: i18n.t("Price_tooltip"),
    },
    discount: {
      class: "right",
      width: 150,
      name: i18n.t("Discount_Per_Unit"),
      hidden: false,
      columnName: "O",
      positionTooltip: "right",
      tooltip: i18n.t("Disc_Q_tooltip"),
    },
    preVatAmount: {
      class: "right",
      width: 150,
      name: i18n.t("Pre_VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Pre_VAT_Amount_tooltip.first") },
        { content: i18n.t("Pre_VAT_Amount_tooltip.second") },
      ],
    },
    vatType: {
      class: "left",
      width: 80,
      name: i18n.t("VAT"),
      hidden: false,
      columnName: "P",
    },
    vatAmount: {
      class: "right",
      width: 130,
      name: i18n.t("VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: [{ content: i18n.t("VAT_Amount_tooltip.first") }, { content: i18n.t("VAT_Amount_tooltip.second") }],
    },
    netAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Net_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: i18n.t("Net_Amount_tooltip"),
    },
    wht: {
      class: "right hearderLast",
      width: 130,
      name: i18n.t("WHT"),
      hidden: false,
      columnName: "Q",
      positionTooltip: "left",
      tooltip: i18n.t("WHT_tooltip"),
    },
    paymentBankAccount: {
      hidden: true,
    },
    paymentAmount: {
      hidden: true,
    },
    paymentWhtAmount: {
      hidden: true,
    },
    pnd: {
      hidden: true,
    },
    remark: {
      class: "left",
      width: 200,
      name: i18n.t("Remark"),
      hidden: false,
      columnName: "R",
      positionTooltip: "left",
      tooltip: i18n.t("Remark_for_customer_placeholder"),
    },
    classification: {
      class: "left",
      width: 160,
      name: i18n.t("Menu_Classification"),
      hidden: isAFPPackage,
      columnName: "S",
      positionTooltip: "left",
      tooltip: i18n.t("Classification_Group_Allocation_Tooltip"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportTemplateReceiptHeader(isAFPPackage) {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    number: {
      class: "left",
      width: 180,
      hidden: false,
      name: i18n.t("Document_No"),
      placeholder: i18n.t("Document_No_Import_placeholder"),
      columnName: "C",
      positionTooltip: "right",
      tooltip: i18n.t("Document_No_Tooltip"),
    },
    reference: {
      class: "left",
      width: 130,
      name: i18n.t("Ref"),
      hidden: false,
      columnName: "D",
      positionTooltip: "right",
      tooltip: i18n.t("Refer_to_placeholder"),
    },
    docDate: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_tooltip"),
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact_Customer"),
      hidden: false,
      columnName: "E,F,G",
    },
    taxInvoice: {
      class: "left",
      width: 160,
      hidden: false,
      name: i18n.t("Tax_Invoice_Issue"),
      columnName: "H",
      positionTooltip: "right",
      tooltip: i18n.t("Tax_Invoice_Import_Tooltip"),
    },
    purchaseTaxInvoiceNumber: {
      hidden: true,
    },
    purchaseTaxInvoiceDate: {
      hidden: true,
    },
    pricingType: {
      class: "left",
      width: 140,
      name: i18n.t("Pricing_Type"),
      hidden: false,
      columnName: "I",
    },
    productTemplate: {
      class: "left",
      width: 200,
      name: i18n.t("Product_Service"),
      hidden: false,
      columnName: "J",
      positionTooltip: "right",
      tooltip: i18n.t("Product_Service_tooltip_Only"),
    },
    accountTemplate: {
      class: "left",
      width: 150,
      name: i18n.t("Expense_Account"),
      hidden: false,
      columnName: "K",
      positionTooltip: "right",
      tooltip: i18n.t("Expense_Account_tooltip"),
    },
    description: {
      class: "left",
      width: 250,
      name: i18n.t("Description"),
      hidden: false,
      columnName: "L",
      positionTooltip: "right",
      tooltip: i18n.t("Description_item_tooltip"),
    },
    quantity: {
      class: "right",
      width: 110,
      name: i18n.t("Quantity"),
      hidden: false,
      columnName: "M",
      positionTooltip: "right",
      tooltip: i18n.t("Quantitye_tooltip"),
    },
    price: {
      class: "right",
      width: 130,
      name: i18n.t("Price_Per_Unit"),
      hidden: false,
      columnName: "N",
      positionTooltip: "right",
      tooltip: i18n.t("Price_tooltip"),
    },
    discount: {
      class: "right",
      width: 150,
      name: i18n.t("Discount_Per_Unit"),
      hidden: false,
      columnName: "O",
      positionTooltip: "right",
      tooltip: i18n.t("Disc_Q_tooltip"),
    },
    preVatAmount: {
      class: "right",
      width: 150,
      name: i18n.t("Pre_VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Pre_VAT_Amount_tooltip.first") },
        { content: i18n.t("Pre_VAT_Amount_tooltip.second") },
      ],
    },
    vatType: {
      class: "left",
      width: 80,
      name: i18n.t("VAT"),
      hidden: false,
      columnName: "P",
    },
    vatAmount: {
      class: "right",
      width: 130,
      name: i18n.t("VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [{ content: i18n.t("VAT_Amount_tooltip.first") }, { content: i18n.t("VAT_Amount_tooltip.second") }],
    },
    netAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Net_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: i18n.t("Net_Amount_tooltip"),
    },
    wht: {
      class: "right",
      width: 130,
      name: i18n.t("WHT"),
      hidden: false,
      columnName: "Q",
      positionTooltip: "right",
      tooltip: i18n.t("WHT_tooltip"),
    },
    paymentBankAccount: {
      class: "left",
      width: 150,
      name: i18n.t("Paid_Receive_at"),
      hidden: false,
      columnName: "R",
    },
    paymentAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Payment_Receive_amount"),
      hidden: false,
      columnName: "",
    },
    paymentWhtAmount: {
      class: "right hearderLast",
      width: 130,
      name: i18n.t("Total_WHT_Amount"),
      hidden: false,
      columnName: "",
    },
    pnd: {
      hidden: true,
    },
    remark: {
      class: "left",
      width: 200,
      name: i18n.t("Remark"),
      hidden: false,
      columnName: "S",
      positionTooltip: "left",
      tooltip: i18n.t("Remark_for_customer_placeholder"),
    },
    classification: {
      class: "left",
      width: 160,
      name: i18n.t("Menu_Classification"),
      hidden: isAFPPackage,
      columnName: "T",
      positionTooltip: "left",
      tooltip: i18n.t("Classification_Group_Allocation_Tooltip"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportReferenceTemplateReceiptHeader() {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    reference: {
      class: "left",
      width: 160,
      name: i18n.t("Reference_Invoice"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
      tooltip: i18n.t("Reference_Invoice_Tooltip"),
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact_Customer"),
      hidden: false,
      columnName: "",
    },
    remainPayment: {
      class: "right",
      width: 160,
      name: i18n.t("Table_Header_Amount_to_pay"),
      hidden: false,
      columnName: "",
    },
    docDate: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "C",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_Ref_tooltip"),
    },
    number: {
      class: "left",
      width: 180,
      hidden: false,
      name: i18n.t("Document_No"),
      placeholder: i18n.t("Document_No_Import_placeholder"),
      columnName: "D",
      positionTooltip: "right",
      tooltip: i18n.t("Document_No_Tooltip"),
    },
    taxInvoice: {
      class: "left",
      width: 160,
      hidden: false,
      name: i18n.t("Tax_Invoice_Issue"),
      columnName: "E",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Tax_Invoice_Import_Tooltip") },
        { content: i18n.t("Tax_Invoice_Import_Tooltip_Second") },
      ],
    },
    paymentBankAccount: {
      class: "left",
      width: 150,
      name: i18n.t("Paid_Receive_at"),
      hidden: false,
      columnName: "F",
    },
    paymentAmount: {
      class: "right",
      width: 160,
      name: i18n.t("Payment_Amount_Income"),
      hidden: false,
      columnName: "G",
      tooltip: i18n.t("Payment_Amount_Import_Tooltip"),
    },
    paymentWhtAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Total_WHT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: i18n.t("Total_WHT_Amount"),
    },
    remark: {
      class: "left",
      width: 200,
      name: i18n.t("Remark"),
      hidden: false,
      columnName: "H",
      positionTooltip: "left",
      tooltip: i18n.t("Remark_for_customer_placeholder"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportTemplateJournalHeader() {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    type: {
      class: "left",
      width: 130,
      name: i18n.t("Journal"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
    },
    date: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "C",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_Ref_tooltip"),
    },
    reference: {
      class: "left",
      width: 160,
      name: i18n.t("Text_Referance"),
      hidden: false,
      columnName: "D",
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact"),
      hidden: false,
      columnName: "E",
    },
    description: {
      class: "left",
      width: 250,
      name: i18n.t("Journal_Transaction_Description"),
      hidden: false,
      columnName: "F",
    },
    account: {
      class: "left",
      width: 130,
      name: i18n.t("Account_Number"),
      hidden: false,
      columnName: "G",
    },
    subAccount: {
      class: "left",
      width: 130,
      name: i18n.t("Sub_account_No"),
      hidden: false,
      columnName: "H",
    },
    descriptionItem: {
      class: "left",
      width: 250,
      name: i18n.t("Description_item"),
      hidden: false,
      columnName: "I",
    },
    debit: {
      class: "right",
      width: 130,
      name: i18n.t("Debit"),
      hidden: false,
      columnName: "J",
    },
    credit: {
      class: "right",
      width: 130,
      name: i18n.t("Credit"),
      hidden: false,
      columnName: "K",
    },
    classification: {
      class: "left",
      width: 160,
      name: i18n.t("Menu_Classification"),
      hidden: false,
      columnName: "L",
      positionTooltip: "left",
      tooltip: i18n.t("Classification_Group_Allocation_Tooltip"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportTemplateQuotationHeader(isAFPPackage) {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    number: {
      hidden: true,
    },
    reference: {
      class: "left",
      width: 130,
      name: i18n.t("Ref"),
      hidden: false,
      columnName: "C",
      positionTooltip: "right",
      tooltip: i18n.t("Refer_to_placeholder"),
    },
    docDate: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_tooltip"),
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact_Customer"),
      hidden: false,
      columnName: "D,E,F",
    },
    taxInvoice: {
      hidden: true,
    },
    purchaseTaxInvoiceNumber: {
      hidden: true,
    },
    purchaseTaxInvoiceDate: {
      hidden: true,
    },
    pricingType: {
      class: "left",
      width: 140,
      name: i18n.t("Pricing_Type"),
      hidden: false,
      columnName: "G",
    },
    productTemplate: {
      class: "left",
      width: 200,
      name: i18n.t("Product_Service"),
      hidden: false,
      columnName: "H",
      positionTooltip: "right",
      tooltip: i18n.t("Product_Service_tooltip_Only"),
    },
    accountTemplate: {
      class: "left",
      width: 150,
      name: i18n.t("Income_Account"),
      hidden: false,
      columnName: "I",
      positionTooltip: "right",
      tooltip: i18n.t("Income_Account_tooltip"),
    },
    description: {
      class: "left",
      width: 250,
      name: i18n.t("Description"),
      hidden: false,
      columnName: "J",
      positionTooltip: "right",
      tooltip: i18n.t("Description_item_tooltip"),
    },
    quantity: {
      class: "right",
      width: 110,
      name: i18n.t("Quantity"),
      hidden: false,
      columnName: "K",
      positionTooltip: "right",
      tooltip: i18n.t("Quantitye_tooltip"),
    },
    price: {
      class: "right",
      width: 150,
      name: i18n.t("Price_Per_Unit"),
      hidden: false,
      columnName: "L",
      positionTooltip: "right",
      tooltip: i18n.t("Price_tooltip"),
    },
    discount: {
      class: "right",
      width: 150,
      name: i18n.t("Discount_Per_Unit"),
      hidden: false,
      columnName: "M",
      positionTooltip: "right",
      tooltip: i18n.t("Disc_Q_tooltip"),
    },
    preVatAmount: {
      class: "right",
      width: 150,
      name: i18n.t("Pre_VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Pre_VAT_Amount_tooltip.first") },
        { content: i18n.t("Pre_VAT_Amount_tooltip.second") },
      ],
    },
    vatType: {
      class: "left",
      width: 80,
      name: i18n.t("VAT"),
      hidden: false,
      columnName: "N",
      positionTooltip: "right",
      tooltip: i18n.t("VAT_tooltip"),
    },
    vatAmount: {
      class: "right",
      width: 130,
      name: i18n.t("VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: [{ content: i18n.t("VAT_Amount_tooltip.first") }, { content: i18n.t("VAT_Amount_tooltip.second") }],
    },
    netAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Net_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: i18n.t("Net_Amount_tooltip"),
    },
    wht: {
      class: "right hearderLast",
      width: 130,
      name: i18n.t("WHT"),
      hidden: false,
      columnName: "O",
      positionTooltip: "left",
      tooltip: i18n.t("WHT_tooltip"),
    },
    paymentBankAccount: {
      hidden: true,
    },
    paymentAmount: {
      hidden: true,
    },
    paymentWhtAmount: {
      hidden: true,
    },
    pnd: {
      hidden: true,
    },
    remark: {
      class: "left",
      width: 200,
      name: i18n.t("Remark"),
      hidden: false,
      columnName: "P",
      positionTooltip: "left",
      tooltip: i18n.t("Remark_for_customer_placeholder"),
    },
    classification: {
      class: "left",
      width: 160,
      name: i18n.t("Menu_Classification"),
      hidden: isAFPPackage,
      columnName: "Q",
      positionTooltip: "left",
      tooltip: i18n.t("Classification_Group_Allocation_Tooltip"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportTemplatePurchaseOrderHeader(isAFPPackage) {
  return {
    status: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
    no: {
      class: "center",
      width: 100,
      name: i18n.t("Doc_No"),
      hidden: false,
      columnName: "A",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Doc_No_tooltip.first") },
        { content: i18n.t("Doc_No_tooltip.second") },
        { content: i18n.t("Doc_No_tooltip.third") },
      ],
    },
    number: {
      hidden: true,
    },
    reference: {
      class: "left",
      width: 130,
      name: i18n.t("Ref"),
      hidden: false,
      columnName: "C",
      positionTooltip: "right",
      tooltip: i18n.t("Refer_to_placeholder"),
    },
    docDate: {
      class: "left",
      width: 130,
      name: i18n.t("Doc_Date"),
      hidden: false,
      columnName: "B",
      positionTooltip: "right",
      tooltip: i18n.t("Doc_Date_tooltip"),
    },
    contact: {
      class: "left",
      width: 160,
      name: i18n.t("Contact_Payee"),
      hidden: false,
      columnName: "D,E,F",
    },
    taxInvoice: {
      hidden: true,
    },
    purchaseTaxInvoiceNumber: {
      hidden: true,
    },
    purchaseTaxInvoiceDate: {
      hidden: true,
    },
    pricingType: {
      class: "left",
      width: 140,
      name: i18n.t("Pricing_Type"),
      hidden: false,
      columnName: "G",
    },
    productTemplate: {
      class: "left",
      width: 200,
      name: i18n.t("Product_Service"),
      hidden: false,
      columnName: "H",
      positionTooltip: "right",
      tooltip: i18n.t("Product_tooltip"),
    },
    accountTemplate: {
      class: "left",
      width: 150,
      name: i18n.t("Income_Account"),
      hidden: false,
      columnName: "I",
      positionTooltip: "right",
      tooltip: i18n.t("Income_Account_tooltip"),
    },
    description: {
      class: "left",
      width: 250,
      name: i18n.t("Description"),
      hidden: false,
      columnName: "J",
      positionTooltip: "right",
      tooltip: i18n.t("Description_item_tooltip"),
    },
    quantity: {
      class: "right",
      width: 110,
      name: i18n.t("Quantity"),
      hidden: false,
      columnName: "K",
      positionTooltip: "right",
      tooltip: i18n.t("Quantitye_tooltip"),
    },
    price: {
      class: "right",
      width: 130,
      name: i18n.t("Price"),
      hidden: false,
      columnName: "L",
      positionTooltip: "right",
      tooltip: i18n.t("Price_tooltip"),
    },
    discount: {
      hidden: true,
    },
    preVatAmount: {
      class: "right",
      width: 150,
      name: i18n.t("Pre_VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "right",
      tooltip: [
        { content: i18n.t("Pre_VAT_Amount_tooltip.first") },
        { content: i18n.t("Pre_VAT_Amount_tooltip.second") },
      ],
    },
    vatType: {
      class: "left",
      width: 80,
      name: i18n.t("VAT"),
      hidden: false,
      columnName: "M",
      positionTooltip: "right",
      tooltip: i18n.t("VAT_tooltip"),
    },
    vatAmount: {
      class: "right",
      width: 130,
      name: i18n.t("VAT_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: [{ content: i18n.t("VAT_Amount_tooltip.first") }, { content: i18n.t("VAT_Amount_tooltip.second") }],
    },
    netAmount: {
      class: "right",
      width: 130,
      name: i18n.t("Net_Amount"),
      hidden: false,
      columnName: "",
      positionTooltip: "left",
      tooltip: i18n.t("Net_Amount_tooltip"),
    },
    wht: {
      class: "right hearderLast",
      width: 130,
      name: i18n.t("WHT"),
      hidden: false,
      columnName: "N",
      positionTooltip: "left",
      tooltip: i18n.t("WHT_tooltip"),
    },
    paymentBankAccount: {
      hidden: true,
    },
    paymentAmount: {
      hidden: true,
    },
    paymentWhtAmount: {
      hidden: true,
    },
    pnd: {
      hidden: true,
    },
    remark: {
      class: "left",
      width: 200,
      name: i18n.t("Remark"),
      columnName: "O",
      hidden: false,
      positionTooltip: "left",
      tooltip: i18n.t("Remark_for_customer_placeholder"),
    },
    classification: {
      class: "left",
      width: 160,
      name: i18n.t("Menu_Classification"),
      hidden: isAFPPackage,
      columnName: "P",
      positionTooltip: "left",
      tooltip: i18n.t("Classification_Group_Allocation_Tooltip"),
    },
    remove: {
      class: "",
      width: 40,
      name: "",
      hidden: false,
      columnName: "",
      positionTooltip: "",
      tooltip: "",
    },
  };
}
function SetImportTemplateProductHeader(
  productType,
  actionType,
  isActiveSkuShopee,
  isActiveSkuLazada,
  isActiveSkuTikTok
) {
  const isProduct = productType === Enums.ProductTemplateType.Product;
  const isService = productType === Enums.ProductTemplateType.Service;
  const isEdit = actionType === Enums.ImportProductActionType.Edit;

  return {
    sequenceNumber: {
      class: "center",
      width: 36,
      name: "",
      hidden: false,
      columnName: "A",
    },
    code: {
      class: "left",
      width: 120,
      hidden: false,
      name: isProduct ? i18n.t("Import_Product_Code") : i18n.t("Import_Service_Code"),
      placeholder: i18n.t("Document_No_Import_placeholder"),
      columnName: "B",
    },
    name: {
      class: "left",
      width: 120,
      name: isProduct ? i18n.t("Import_Product_Name") : i18n.t("Import_Service_Name"),
      hidden: false,
      columnName: "C",
    },
    description: {
      class: "left",
      width: 200,
      name: i18n.t("Description"),
      hidden: false,
      columnName: "D",
    },
    unit: {
      class: "left",
      width: 95,
      hidden: false,
      name: i18n.t("Import_Product_Unit_Name"),
      columnName: "E",
    },
    purchasePrice: {
      class: "left",
      width: i18n.locale === Enums.LanguageType.English ? 150 : 110,
      hidden: false,
      name: i18n.t("Import_Product_Perchase_Price"),
      columnName: "F",
    },
    purchaseVat: {
      class: "left",
      width: 110,
      hidden: false,
      name: i18n.t("Import_Product_Perchase_Vat"),
      columnName: "G",
    },
    sellPrice: {
      class: "left",
      width: i18n.locale === Enums.LanguageType.English ? 150 : 110,
      name: i18n.t("Import_Product_Sell_Price"),
      hidden: false,
      columnName: "H",
    },
    sellVat: {
      class: "left",
      width: 110,
      name: i18n.t("Import_Product_Sell_Vat"),
      hidden: false,
      columnName: "I",
    },
    purchaseAccount: {
      class: "left",
      width: 130,
      name: isProduct ? i18n.t("Import_Product_Purchase_Account") : i18n.t("Import_Service_Purchase_Account"),
      hidden: isProduct && isEdit,
      columnName: "J",
    },
    sellAccount: {
      class: "left",
      width: 130,
      name: i18n.t("Import_Product_Sell_Account"),
      hidden: false,
      columnName: isProduct && isEdit ? "J" : "K",
    },
    costCalculation: {
      class: "left",
      width: 150,
      name: i18n.t("Import_Product_Cost_Calculation"),
      hidden: isService || (isProduct && isEdit),
      columnName: "L",
    },
    costCalculationMethod: {
      class: "left",
      width: 95,
      name: i18n.t("Import_Product_Cost_Calculation_Method"),
      hidden: isService || (isProduct && isEdit),
      columnName: "M",
    },
    costAccount: {
      class: "left",
      width: 150,
      name: i18n.t("Import_Product_Cost_Calculation_Account"),
      hidden: isService || (isProduct && isEdit),
      columnName: "N",
    },
    beginningDate: {
      class: "left",
      width: i18n.locale === Enums.LanguageType.English ? 130 : 110,
      name: i18n.t("Import_Product_Beginning_Date"),
      hidden: isService || (isProduct && isEdit),
      columnName: "O",
    },
    beginningAmount: {
      class: "left",
      width: 110,
      name: i18n.t("Import_Product_Beginning_Amount"),
      hidden: isService || (isProduct && isEdit),
      columnName: "P",
    },
    beginningPrice: {
      class: "left",
      width: 110,
      name: i18n.t("Import_Product_Beginning_Price"),
      hidden: isService || (isProduct && isEdit),
      columnName: "Q",
    },
    skuShopee: {
      class: "left",
      width: 130,
      name: i18n.t("Import_Type_Shopee"),
      hidden: isService || !isActiveSkuShopee,
      columnName: isEdit ? "K" : "R",
    },
    skuLazada: {
      class: "left",
      width: 130,
      name: i18n.t("Import_Type_Lazada"),
      hidden: isService || !isActiveSkuLazada,
      columnName: isEdit ? "L" : "S",
    },
    skuTiktok: {
      class: "left",
      width: 130,
      name: i18n.t("Import_Product_Sku_Tiktok"),
      hidden: isService || !isActiveSkuTikTok,
      columnName: isEdit ? "M" : "T",
    },
    skuBarcode: {
      class: "left",
      width: 130,
      name: i18n.t("Import_Product_Sku_Barcode"),
      hidden: isService,
      columnName: isEdit ? "N" : "U",
    },
    close: {
      class: "center",
      width: 36,
      name: "",
      hidden: false,
      columnName: "",
    },
  };
}
function SetImportTemplateContactHeader() {
  return {
    sequenceNumber: {
      class: "center",
      width: 36,
      name: "",
      hidden: false,
      columnName: "A",
    },
    code: {
      class: "left",
      width: 120,
      hidden: false,
      name: i18n.t("Contact_Code"),
      columnName: "B",
    },
    contactFinanceType: {
      class: "left",
      width: 120,
      hidden: false,
      name: i18n.t("Contact_FinanceTypeType"),
      columnName: "C",
    },
    country: {
      class: "left",
      width: 120,
      name: i18n.t("Nationality"),
      hidden: false,
      columnName: "D",
    },
    taxId: {
      class: "left",
      width: 150,
      name: i18n.t("Tax_Id"),
      hidden: false,
      columnName: "E",
    },
    branchType: {
      class: "left",
      width: 150,
      hidden: false,
      name: i18n.t("HeadQuarters_Branch"),
      columnName: "",
    },
    branchCode: {
      class: "left",
      width: 120,
      hidden: false,
      name: i18n.t("Branch_No"),
      columnName: "F",
    },
    personType: {
      class: "left",
      width: 120,
      hidden: false,
      name: i18n.t("Merchant_Type"),
      columnName: "",
    },
    merchantType: {
      class: "left",
      width: 140,
      name: i18n.t("Organization_Type"),
      hidden: false,
      columnName: "G",
    },
    prefixName: {
      class: "left",
      width: 120,
      name: i18n.t("Prefix"),
      hidden: false,
      columnName: "H",
    },
    firstName: {
      class: "left",
      width: 120,
      name: i18n.t("Merchant_Name"),
      hidden: false,
      columnName: "I",
    },
    lastName: {
      class: "left",
      width: 120,
      name: i18n.t("last_name"),
      hidden: false,
      columnName: "J",
    },
    registeredName: {
      class: "left",
      width: 120,
      name: i18n.t("Person"),
      hidden: false,
      columnName: "K",
    },
    registeredAddress: {
      class: "left",
      width: 130,
      name: i18n.t("Input_Address"),
      hidden: false,
      columnName: "L",
    },
    registeredSubDistrict: {
      class: "left",
      width: 110,
      name: i18n.t("Input_Sub_district"),
      hidden: false,
      columnName: "M",
    },
    registeredDistrict: {
      class: "left",
      width: 110,
      name: i18n.t("Input_amphoe"),
      hidden: false,
      columnName: "N",
    },
    registeredProvince: {
      class: "left",
      width: 120,
      name: i18n.t("Input_Province"),
      hidden: false,
      columnName: "O",
    },
    registeredPostcode: {
      class: "left",
      width: 120,
      name: i18n.t("Input_Postal_Code"),
      hidden: false,
      columnName: "P",
    },
    officeName: {
      class: "left",
      width: 120,
      name: i18n.t("Person"),
      hidden: false,
      columnName: "Q",
    },
    officeAddress: {
      class: "left",
      width: 130,
      name: i18n.t("Input_Address"),
      hidden: false,
      columnName: "R",
    },
    officeSubDistrict: {
      class: "left",
      width: 110,
      name: i18n.t("Input_Sub_district"),
      hidden: false,
      columnName: "S",
    },
    officeDistrict: {
      class: "left",
      width: 110,
      name: i18n.t("Input_amphoe"),
      hidden: false,
      columnName: "T",
    },
    officeProvince: {
      class: "left",
      width: 120,
      name: i18n.t("Input_Province"),
      hidden: false,
      columnName: "U",
    },
    officePostcode: {
      class: "left",
      width: 120,
      name: i18n.t("Input_Postal_Code"),
      hidden: false,
      columnName: "V",
    },
    email: {
      class: "left",
      width: 120,
      name: i18n.t("Email"),
      hidden: false,
      columnName: "W",
    },
    phone: {
      class: "left",
      width: 100,
      name: i18n.t("Input_tel"),
      hidden: false,
      columnName: "X",
    },
    website: {
      class: "left",
      width: 110,
      name: i18n.t("Input_website"),
      hidden: false,
      columnName: "Y",
    },
    fax: {
      class: "left",
      width: 110,
      name: i18n.t("Input_tel_fax"),
      hidden: false,
      columnName: "Z",
    },
    bankName: {
      class: "left",
      width: 120,
      name: i18n.t("Bank"),
      hidden: false,
      columnName: "AA",
    },
    bankAccountName: {
      class: "left",
      width: 120,
      name: i18n.t("Account_Name"),
      hidden: false,
      columnName: "AB",
    },
    bankAccountNumber: {
      class: "left",
      width: 120,
      name: i18n.t("Account_Number"),
      hidden: false,
      columnName: "AC",
    },
    bankBranch: {
      class: "left",
      width: 120,
      name: i18n.t("Branch_Number"),
      hidden: false,
      columnName: "AD",
    },
    invoiceDueDateType: {
      class: "left",
      width: 180,
      name: i18n.t("Invoice_Credit_Term"),
      hidden: false,
      columnName: "AE",
    },
    invoiceDueDate: {
      class: "left",
      width: 120,
      name: i18n.t("X_Variable"),
      hidden: false,
      columnName: "AF",
    },
    expenseDueDateType: {
      class: "left",
      width: 180,
      name: i18n.t("Expense_Credit_Term"),
      hidden: false,
      columnName: "AG",
    },
    expenseDueDate: {
      class: "left",
      width: 120,
      name: i18n.t("X_Variable"),
      hidden: false,
      columnName: "AH",
    },
    receivableAccount: {
      class: "left",
      width: 180,
      name: i18n.t("Receivable_Recorded"),
      hidden: false,
      columnName: "AI",
    },
    payableAccount: {
      class: "left",
      width: 180,
      name: i18n.t("Payable_Recorded"),
      hidden: false,
      columnName: "AJ",
    },
    creditLimitType: {
      class: "left",
      width: 120,
      name: i18n.t("CreditLimitInput.Header_CreditLimitInput"),
      hidden: false,
      columnName: "AK",
    },
    creditLimit: {
      class: "right",
      width: 120,
      name: i18n.t("Amount_Baht_Input"),
      hidden: false,
      columnName: "AL",
    },
    personNamePrefix: {
      class: "left",
      width: 120,
      name: i18n.t("Prefix"),
      hidden: false,
      columnName: "AM",
    },
    personFirstName: {
      class: "left",
      width: 120,
      name: i18n.t("Firstname"),
      hidden: false,
      columnName: "AN",
    },
    personLastName: {
      class: "left",
      width: 120,
      name: i18n.t("last_name"),
      hidden: false,
      columnName: "AO",
    },
    personNickName: {
      class: "left",
      width: 120,
      name: i18n.t("NickName"),
      hidden: false,
      columnName: "AP",
    },
    personEmail: {
      class: "left",
      width: 120,
      name: i18n.t("Email"),
      hidden: false,
      columnName: "AQ",
    },
    personPhone: {
      class: "left",
      width: 120,
      name: i18n.t("Input_tel"),
      hidden: false,
      columnName: "AR",
    },
    personPosition: {
      class: "left",
      width: 120,
      name: i18n.t("Position_Register"),
      hidden: false,
      columnName: "AS",
    },
    personDepartment: {
      class: "left",
      width: 120,
      name: i18n.t("Position_Department"),
      hidden: false,
      columnName: "AT",
    },
    group: {
      class: "left",
      width: 120,
      name: "",
      hidden: false,
      columnName: "AU",
    },
    remove: {
      class: "",
      width: 36,
      name: "",
      hidden: false,
      columnName: "",
    },
  };
}
function SetImportTemplateContactSubjectHeader() {
  return {
    contactHeader: {
      class: "center",
      width: 1406,
      hidden: false,
      name: i18n.t("Contact_Information"),
    },
    registerHeader: {
      class: "center",
      width: 712,
      hidden: false,
      name: i18n.t("Registered_Address_Information"),
    },
    officeHeader: {
      class: "center",
      width: 710,
      hidden: false,
      name: i18n.t("Office_address"),
    },
    contactChannelHeader: {
      class: "center",
      width: 440,
      hidden: false,
      name: i18n.t("Contact_Number"),
    },
    bankAccountHeader: {
      class: "center",
      width: 480,
      hidden: false,
      name: i18n.t("Contact_Bank"),
    },
    settingDueDateHeader: {
      class: "center",
      width: 598,
      hidden: false,
      name: i18n.t("Contact_Credit_Term"),
    },
    settingAccountHeader: {
      class: "center",
      width: 360,
      hidden: false,
      name: i18n.t("Account_Record_Setting"),
    },
    creditLimitHeader: {
      class: "center",
      width: 236,
      hidden: false,
      name: i18n.t("Credit_limit_setting"),
    },
    contactPersonHeader: {
      class: "center",
      width: 962,
      hidden: false,
      name: i18n.t("Contact_Person"),
    },
    groupHeader: {
      class: "center",
      width: 120,
      hidden: false,
      name: i18n.t("Group"),
    },
  };
}
//#endregion

//#region Helper
function SelectedContact(contact, itemContact) {
  let selectedContact = contact;

  if (itemContact) {
    selectedContact.contactCode = itemContact.contactCode;
    selectedContact.id = itemContact.id;
    selectedContact.contactFullName = itemContact.contactFullName;
    selectedContact.contactFullNameTh = itemContact.contactFullNameTh;
    selectedContact.contactFullNameEng = itemContact.contactFullNameEng;
    selectedContact.contactName = itemContact.contactName;
    selectedContact.contactBranchCode = itemContact.contactBranchCode;
    selectedContact.contactTaxId = itemContact.contactTaxId;
    selectedContact.address = itemContact.address;
    selectedContact.contactType = itemContact.contactType;
    selectedContact.phoneNumber = itemContact.phoneNumber;
    selectedContact.incomeDueDateTypeId = itemContact.incomeDueDateTypeId;
    selectedContact.incomeDueDateDay = itemContact.incomeDueDateDay;
    selectedContact.outflowDueDateTypeId = itemContact.outflowDueDateTypeId;
    selectedContact.outflowDueDateDay = itemContact.outflowDueDateDay;
    selectedContact.contactWhtType = itemContact.contactWhtType;
    selectedContact.creditLimit = itemContact.creditLimit;
    selectedContact.creditLimitSettingType = itemContact.creditLimitSettingType;
    selectedContact.country = itemContact.country;
    selectedContact.validateError = false;
  } else {
    selectedContact.contactCode = "";
    selectedContact.id = 0;
    selectedContact.contactFullName = "";
    selectedContact.contactBranchCode = "";
    selectedContact.contactTaxId = "";
  }
  return selectedContact;
}
function SelectedProduct(product, itemProduct) {
  let productItem = product;
  if (itemProduct) {
    productItem.code = itemProduct.code;
    productItem.id = itemProduct.id;
    productItem.name = itemProduct.name;
    productItem.productTypeId = itemProduct.typeId;
    productItem.typeId = itemProduct.typeId;
  } else {
    productItem.code = "";
    productItem.id = 0;
    productItem.name = "";
    productItem.productTypeId = 0;
  }

  return productItem;
}

function CheckAndRemoveText(allDescription, textDescription) {
  let textDescriptionForSearch = textDescription == allDescription ? textDescription : textDescription + " ";
  let indexOfFirst = allDescription.indexOf(textDescriptionForSearch);
  if (indexOfFirst == 0) {
    let textDescriptionLength = textDescription.length;
    allDescription = allDescription.substring(textDescriptionLength).trim();
  }
  return allDescription;
}

function SuggestionDescription(newDescription, oldDescription, allDescription) {
  let suggestionDescription = "";
  newDescription = newDescription ? newDescription.trim() : "";
  oldDescription = oldDescription ? oldDescription.trim() : "";
  allDescription = allDescription ? allDescription.trim() : "";
  if (!allDescription) {
    suggestionDescription = newDescription;
  } else if (newDescription) {
    allDescription = CheckAndRemoveText(allDescription, newDescription);
    if (oldDescription) {
      allDescription = CheckAndRemoveText(allDescription, oldDescription);
    }
    suggestionDescription = newDescription + " " + allDescription;
  } else {
    suggestionDescription = allDescription;
  }
  return suggestionDescription;
}
function RemoveTextInDescription(text, allDescription) {
  let description = "";
  text = text.trim();
  allDescription = allDescription ? allDescription.trim() : "";
  if (!allDescription) {
    description = "";
  } else if (text) {
    allDescription = CheckAndRemoveText(allDescription, text);
    description = allDescription;
  } else {
    description = allDescription;
  }
  return description;
}

function SelectVatType(taxStatus, vatTypeId) {
  if (taxStatus === Enums.TaxTypeId.None) {
    return Enums.ProductVatType.None;
  }

  return transactionItemHelper.CheckVatOptions(vatTypeId).value;
}

function SelectedProductTransaction(transactionItem, itemProduct, transactionType, financeType, taxStatus) {
  let selectedTransactionItem = transactionItem;

  let oldDescription =
    selectedTransactionItem.productTemplate.name +
    (selectedTransactionItem.productTemplate.description
      ? " : " + selectedTransactionItem.productTemplate.description
      : "");

  if (itemProduct) {
    let newDescription = itemProduct.name + (itemProduct.description ? " : " + itemProduct.description : "");
    const productPurchasePrice = (itemProduct.purchasePrice || 0).ToPeakTransactionItemFormat();
    const productSellPrice = (itemProduct.sellPrice || 0).ToPeakTransactionItemFormat();
    if (selectedTransactionItem.vatTypeId.isSuggestion) {
      if (financeType === Enums.FinanceType.OutFlow) {
        selectedTransactionItem.vatTypeId.value = SelectVatType(taxStatus, itemProduct.purchaseVatType);
      } else {
        selectedTransactionItem.vatTypeId.value = SelectVatType(taxStatus, itemProduct.sellVatType);
      }
      selectedTransactionItem.vatTypeId.isSuggestion = false;
    }
    if (!selectedTransactionItem.productTemplate.isNotAuto) {
      if (selectedTransactionItem.productTemplate.id !== itemProduct.id) {
        selectedTransactionItem.account.isNotAuto = true;
        selectedTransactionItem.account.id = GetAccountIdFromSelectProduct(itemProduct, transactionType, financeType);
        selectedTransactionItem.vatTypeId.value = GetVatTypeIdFromSelectProduct(itemProduct, financeType, taxStatus);
        selectedTransactionItem.price.value = GetPriceFromSelectProduct(
          selectedTransactionItem.price.value,
          itemProduct,
          financeType,
          selectedTransactionItem.referenceQuotationItemId
        );

        if (!selectedTransactionItem.referenceQuotationItemId) {
          selectedTransactionItem.description.text = RemoveTextInDescription(
            selectedTransactionItem.account.name,
            selectedTransactionItem.description.text
          );

          selectedTransactionItem.description.text = SuggestionDescription(
            newDescription,
            oldDescription,
            selectedTransactionItem.description.text
          );
        }
      }
    } else {
      if (selectedTransactionItem.description.text == null || selectedTransactionItem.description.text === "") {
        selectedTransactionItem.description.text = SuggestionDescription(
          newDescription,
          oldDescription,
          selectedTransactionItem.description.text
        );
      }
      if (
        selectedTransactionItem.account.id == 0 &&
        (selectedTransactionItem.account.code == null || selectedTransactionItem.account.code === "")
      ) {
        selectedTransactionItem.account.id = GetAccountIdFromSelectProduct(itemProduct, transactionType, financeType);
      }
    }
    selectedTransactionItem.productTemplate.code = itemProduct.code;
    selectedTransactionItem.productTemplate.id = itemProduct.id;
    selectedTransactionItem.productTemplate.name = itemProduct.name;
    selectedTransactionItem.productTemplate.description = itemProduct.description;
    selectedTransactionItem.productTemplate.productTypeId = itemProduct.typeId;
    selectedTransactionItem.productTemplate.typeId = itemProduct.typeId;
    selectedTransactionItem.productTemplate.validateError = false;
    selectedTransactionItem.productTemplate.unitNameTh = itemProduct.unitNameTh;
    selectedTransactionItem.productTemplate.unitNameEng = itemProduct.unitNameEng;
    selectedTransactionItem.productTemplate.standardPrice =
      financeType === Enums.FinanceType.OutFlow ? productPurchasePrice : productSellPrice;
    selectedTransactionItem.productTemplate.remainStockAmount = itemProduct.remainStockAmount;
    selectedTransactionItem.remainStock.value = itemProduct.remainStockAmount;
    selectedTransactionItem.remainStock.isProduct = itemProduct.typeId === Enums.ProductTemplateType.Product;
  } else {
    selectedTransactionItem.description.text = RemoveTextInDescription(
      oldDescription,
      selectedTransactionItem.description.text
    );
    if (selectedTransactionItem.description.text == "" && selectedTransactionItem.account.id > 0) {
      selectedTransactionItem.description.text = selectedTransactionItem.account.name;
    }
    selectedTransactionItem.productTemplate.code = "";
    selectedTransactionItem.productTemplate.name = "";
    selectedTransactionItem.productTemplate.description = "";
    selectedTransactionItem.productTemplate.id = 0;
    selectedTransactionItem.productTemplate.validateError = false;
    selectedTransactionItem.productTemplate.unitNameTh = "";
    selectedTransactionItem.productTemplate.unitNameEng = "";
    selectedTransactionItem.remainStock.value = 0;
    selectedTransactionItem.remainStock.isProduct = false;
  }

  return selectedTransactionItem;
}

function GetAccountIdFromSelectProduct(itemProduct, transactionType, financeType) {
  let accountId = 0;
  if (transactionType !== Enums.TransactionType.Deposit) {
    if (financeType === Enums.FinanceType.OutFlow) {
      accountId = itemProduct.purchaseAccountId;
    } else {
      accountId = itemProduct.sellAccountId;
    }
  }
  return accountId;
}

function GetVatTypeIdFromSelectProduct(itemProduct, financeType, taxStatus) {
  let vatTypeId = 0;

  if (financeType === Enums.FinanceType.OutFlow) {
    vatTypeId =
      taxStatus === Enums.TaxTypeId.None
        ? Enums.ProductVatType.None
        : itemProduct.purchaseVatType == Enums.ProductVatType.ZeroPercent
        ? Enums.ProductVatType.SevenPercent
        : itemProduct.purchaseVatType;
  } else {
    vatTypeId = taxStatus === Enums.TaxTypeId.None ? Enums.ProductVatType.None : itemProduct.sellVatType;
  }

  return vatTypeId;
}

function GetPriceFromSelectProduct(defaultPrice, itemProduct, financeType, referenceQuotationItemId) {
  let price = defaultPrice;

  const productPurchasePrice = (itemProduct.purchasePrice || 0).ToPeakTransactionItemFormat();
  const productSellPrice = (itemProduct.sellPrice || 0).ToPeakTransactionItemFormat();

  if (financeType === Enums.FinanceType.OutFlow) {
    if (!referenceQuotationItemId) {
      price = productPurchasePrice;
    }
  } else {
    if (!referenceQuotationItemId) {
      price = productSellPrice;
    }
  }

  return price;
}
function SelectedAssetTemplate(assetTemplate, itemAssetTemplate) {
  let assetTemplateItem = assetTemplate;

  if (itemAssetTemplate) {
    assetTemplateItem.code = itemAssetTemplate.code;
    assetTemplateItem.id = itemAssetTemplate.id;
    assetTemplateItem.name = itemAssetTemplate.name;
  } else {
    assetTemplateItem.code = "";
    assetTemplateItem.id = 0;
    assetTemplateItem.name = "";
  }
  return assetTemplateItem;
}
function SelectedAssetTemplateTransaction(transactionItem, itemAssetTemplate) {
  let selectedTransactionItem = transactionItem;

  if (itemAssetTemplate) {
    const isChangeDescription = selectedTransactionItem.fixedAssetTemplate.id != itemAssetTemplate.id;
    selectedTransactionItem.fixedAssetTemplate.code = itemAssetTemplate.code;
    selectedTransactionItem.fixedAssetTemplate.id = itemAssetTemplate.id;
    selectedTransactionItem.fixedAssetTemplate.name = itemAssetTemplate.name;

    selectedTransactionItem.fixedAssetTemplate.validateError = false;

    if (!selectedTransactionItem.fixedAssetTemplate.isNotAuto) {
      selectedTransactionItem.account.isNotAuto = true;

      selectedTransactionItem.account.id = itemAssetTemplate.assetAccountId;

      if (!selectedTransactionItem.referenceQuotationItemId && isChangeDescription) {
        selectedTransactionItem.description.text = itemAssetTemplate.name ? itemAssetTemplate.name : "";
      }
    } else if (!transactionItem.account.isNotAuto) {
      selectedTransactionItem.account.id = itemAssetTemplate.assetAccountId;

      if (selectedTransactionItem.description.text == null || selectedTransactionItem.description.text === "") {
        selectedTransactionItem.description.text = itemAssetTemplate.name ? itemAssetTemplate.name : "";
      }
    } else {
      if (selectedTransactionItem.description.text == null || selectedTransactionItem.description.text === "") {
        selectedTransactionItem.description.text = itemAssetTemplate.name ? itemAssetTemplate.name : "";
      }
      if (
        selectedTransactionItem.account.id == 0 &&
        (selectedTransactionItem.account.code == null || selectedTransactionItem.account.code === "")
      ) {
        selectedTransactionItem.account.id = itemAssetTemplate.assetAccountId;
      }
    }
  } else {
    selectedTransactionItem.fixedAssetTemplate.code = "";
    selectedTransactionItem.fixedAssetTemplate.id = 0;
    selectedTransactionItem.fixedAssetTemplate.validateError = false;

    selectedTransactionItem.account.id = 0;
    selectedTransactionItem.account.code = "";
  }
  return selectedTransactionItem;
}
function SelectedAsset(transactionItem, itemAsset) {
  let selectedTransactionItem = transactionItem;
  if (itemAsset) {
    selectedTransactionItem.fixedAsset.code = itemAsset.code;
    selectedTransactionItem.fixedAsset.id = itemAsset.id;

    selectedTransactionItem.fixedAsset.validateError = false;

    if (
      !selectedTransactionItem.fixedAsset.isNotAuto ||
      selectedTransactionItem.description.text == null ||
      selectedTransactionItem.description.text === ""
    ) {
      let description = "";
      if (selectedTransactionItem.fixedAssetTemplate && selectedTransactionItem.fixedAssetTemplate.name) {
        description += selectedTransactionItem.fixedAssetTemplate.name;
      }
      if (itemAsset.code) {
        description += " - " + itemAsset.code;
      }
      selectedTransactionItem.description.text = description;
    }
  } else {
    selectedTransactionItem.fixedAsset.code = "";
    selectedTransactionItem.fixedAsset.id = 0;
    selectedTransactionItem.fixedAsset.validateError = false;
  }
  return selectedTransactionItem;
}
function SelectedAccount(transactionItem, itemAccount, transactionType, financeType) {
  let selectedTransactionItem = transactionItem;
  if (itemAccount) {
    let newDescription = itemAccount.name.locale;
    let oldDescription = selectedTransactionItem.account.name;

    if (!selectedTransactionItem.account.isNotAuto) {
      if (selectedTransactionItem.account.id !== itemAccount.id && !selectedTransactionItem.referenceQuotationItemId) {
        selectedTransactionItem.description.text = SuggestionDescription(
          newDescription,
          oldDescription,
          selectedTransactionItem.description.text
        );
      }

      SetVatTypeIdBySuggestAccountVatType(selectedTransactionItem, itemAccount, transactionType, financeType);
    } else if (selectedTransactionItem.vatTypeId.isSuggestion) {
      SetVatTypeIdBySuggestAccountVatType(selectedTransactionItem, itemAccount, transactionType, financeType);
      selectedTransactionItem.vatTypeId.isSuggestion = false;
      if (selectedTransactionItem.description.text == null || selectedTransactionItem.description.text === "") {
        selectedTransactionItem.description.text = SuggestionDescription(
          newDescription,
          oldDescription,
          selectedTransactionItem.description.text
        );
      }
    } else if (selectedTransactionItem.description.text == null || selectedTransactionItem.description.text === "") {
      if (selectedTransactionItem.account.id !== itemAccount.id) {
        selectedTransactionItem.description.text = SuggestionDescription(
          newDescription,
          oldDescription,
          selectedTransactionItem.description.text
        );
      }
    }

    selectedTransactionItem.account.code = itemAccount.code;
    selectedTransactionItem.account.id = itemAccount.id;
    selectedTransactionItem.account.name = itemAccount.name.locale;
    selectedTransactionItem.account.taxIncomeTypeId = itemAccount.taxIncomeTypeId;
  } else {
    selectedTransactionItem.account.code = "";
    selectedTransactionItem.account.id = "";
    selectedTransactionItem.account.name = "";
    selectedTransactionItem.account.taxIncomeTypeId = "";
  }

  return selectedTransactionItem;
}
function SelectedBankAccount(bankAccount, itemBankAccount) {
  let paymentTransactionBankAccount = bankAccount;
  if (itemBankAccount) {
    paymentTransactionBankAccount.bankAccountCode = itemBankAccount.code;
    paymentTransactionBankAccount.bankAccountId = itemBankAccount.id;
    paymentTransactionBankAccount.bankAccountName = itemBankAccount.name;
    paymentTransactionBankAccount.isEWht = itemBankAccount.isEWht;
  } else {
    paymentTransactionBankAccount.bankAccountCode = "";
    paymentTransactionBankAccount.bankAccountId = "";
    paymentTransactionBankAccount.bankAccountName = "";
    paymentTransactionBankAccount.isEWht = false;
  }
  return paymentTransactionBankAccount;
}
function SelectedInvoiceReference(invoiceRef, itemInvoiceRef, transaction, contactList, canCreateTaxInvoiceNotVat) {
  let reference = invoiceRef;
  if (itemInvoiceRef && invoiceRef.referenceId !== itemInvoiceRef.id) {
    let paymentWhtAmount = itemInvoiceRef.transactionSummaryModel.remainWhtPaymentNetAmount.ToAccountingRoundUp();
    let paymentNetAmount = peakUtility
      .PeakOperatorSubtract(
        itemInvoiceRef.transactionSummaryModel.remainPaymentNetAmount,
        itemInvoiceRef.transactionSummaryModel.remainWhtPaymentNetAmount
      )
      .ToAccountingRoundUp();
    OnChangeImportTransactionReceiptFromInvoice(
      transaction,
      itemInvoiceRef,
      paymentNetAmount,
      paymentWhtAmount,
      itemInvoiceRef.issueDate,
      contactList,
      canCreateTaxInvoiceNotVat
    );

    reference.referenceId = itemInvoiceRef.id;
    reference.referenceName = itemInvoiceRef.invoiceNumber;
  }
  return reference;
}
function SelectTransactionReferenceDocumentPayment(
  _paymentTransactionDocument,
  itemPaymentTransactionDocument,
  paymentInOutFlowType
) {
  let paymentTransactionDocument = _paymentTransactionDocument;
  if (itemPaymentTransactionDocument) {
    paymentTransactionDocument.transactionId = itemPaymentTransactionDocument.id;
    paymentTransactionDocument.transactionNumber = itemPaymentTransactionDocument.number;
    paymentTransactionDocument.transactionRemainPayment = itemPaymentTransactionDocument.remainPayment;
    paymentTransactionDocument.paymentInOutFlowType = paymentInOutFlowType;
    paymentTransactionDocument.transactionNumberValidationError = false;

    if (!paymentTransactionDocument.transactionIsNotAuto) {
      paymentTransactionDocument.paymentAmount = itemPaymentTransactionDocument.remainPayment.FormatMoney();
    }
  } else {
    paymentTransactionDocument.transactionId = 0;
    paymentTransactionDocument.transactionNumber = "";
    paymentTransactionDocument.transactionNumberValidationError = false;
  }
  return paymentTransactionDocument;
}

function SetVatTypeIdBySuggestAccountVatType(transactionItem, item, transactionType, financeType) {
  if (
    financeType == Enums.FinanceType.OutFlow &&
    transactionType == Enums.TransactionType.Invoice &&
    transactionItem.productTemplate.id == 0 &&
    item.suggestAccountVatType >= Enums.ShippingVatType.None &&
    item.suggestAccountVatType <= Enums.ShippingVatType.SevenPercent
  ) {
    transactionItem.vatTypeId.value = item.suggestAccountVatType;
  }
}
//#endregion

function GetObjectDataListForJournal(transactionList, accountList) {
  let contactIdList = [];
  let contactCodeList = [];
  let contactTaxIdList = [];
  let productIdList = [];
  let productCodeList = [];
  let chequeIdList = [];
  let chequeCodeList = [];
  if (transactionList && transactionList.length > 0) {
    transactionList.forEach((transaction) => {
      if (transaction.contact && transaction.contact.contactId > 0) {
        contactIdList.push(transaction.contact.contactId);
      } else if (transaction.contact && transaction.contact.code && transaction.contact.code.length !== 0) {
        contactCodeList.push(transaction.contact.code);
      }

      if (transaction.entityItem && transaction.entityItem.length > 0) {
        transaction.entityItem.forEach((entityItem) => {
          if (accountList && accountList.length > 0) {
            let selectedAccount;
            if (entityItem.accountId >= 0 && entityItem.accountCode) {
              selectedAccount = accountList.find((x) => x.code == entityItem.accountCode);
              if (selectedAccount) {
                entityItem.referenceTypeId = selectedAccount.referenceTypeId;
              }
            }
          }
          switch (entityItem.referenceTypeId) {
            case Enums.JournalAccountReferenceType.BankAccount:
              break;
            case Enums.JournalAccountReferenceType.Cheque:
              if (entityItem.accountSubCode) {
                chequeCodeList.push(entityItem.accountSubCode);
              }
              break;
            case Enums.JournalAccountReferenceType.Contact:
              if (entityItem.accountSubCode) {
                contactCodeList.push(entityItem.accountSubCode);
              }
              break;
            case Enums.JournalAccountReferenceType.ProductTemplate:
              if (entityItem.accountSubCode) {
                productCodeList.push(entityItem.accountSubCode);
              }
              break;
          }
        });
      }
    });
  }

  return {
    contactIdList: contactIdList,
    contactCodeList: contactCodeList,
    contactTaxIdList: contactTaxIdList,
    productIdList: productIdList,
    productCodeList: productCodeList,
    chequeIdList: chequeIdList,
    chequeCodeList: chequeCodeList,
  };
}
function GetObjectDataListForTransaction(transactionList) {
  let contactIdList = [];
  let contactCodeList = [];
  let contactTaxIdList = [];
  let productIdList = [];
  let productCodeList = [];

  if (transactionList && transactionList.length > 0) {
    transactionList.forEach((transaction) => {
      if (transaction.contact && transaction.contact.contactId > 0) {
        contactIdList.push(transaction.contact.contactId);
      } else if (transaction.contact && transaction.contact.code && transaction.contact.code.length !== 0) {
        contactCodeList.push(transaction.contact.code);
      } else if (transaction.contact && transaction.contact.taxId && transaction.contact.taxId.length !== 0) {
        contactTaxIdList.push(transaction.contact.taxId);
      }

      if (transaction.productItem && transaction.productItem.length > 0) {
        transaction.productItem.forEach((productItem) => {
          if (productItem.productTemplate && productItem.productTemplate.productId > 0) {
            productIdList.push(productItem.productTemplate.productId);
          } else if (productItem.productTemplate && productItem.productTemplate.code) {
            productCodeList.push(productItem.productTemplate.code);
          }
        });
      }
    });
  }

  return {
    contactIdList: contactIdList,
    contactCodeList: contactCodeList,
    contactTaxIdList: contactTaxIdList,
    productIdList: productIdList,
    productCodeList: productCodeList,
  };
}
function GetObjectDataListForReceiptFromInvoice(transactionList, invoiceList) {
  let contactIdList = [];
  let contactCodeList = [];
  let contactTaxIdList = [];
  let productIdList = [];
  let productCodeList = [];

  if (transactionList && transactionList.length > 0) {
    transactionList.forEach((transaction) => {
      if (transaction.referenceInvoice) {
        let selectedInvoice = null;
        if (transaction.referenceInvoice.invoiceId > 0) {
          selectedInvoice = invoiceList.find((x) => x.id === transaction.referenceInvoice.invoiceId);
        } else if (transaction.referenceInvoice.invoiceNumber !== "") {
          selectedInvoice = invoiceList.find((x) => x.invoiceNumber === transaction.referenceInvoice.invoiceNumber);
        }

        if (selectedInvoice) {
          contactIdList.push(selectedInvoice.contactId);
        }
      }
    });
  }

  return {
    contactIdList: contactIdList,
    contactCodeList: contactCodeList,
    contactTaxIdList: contactTaxIdList,
    productIdList: productIdList,
    productCodeList: productCodeList,
  };
}

export default {
  CreateTransactionBaseModel(transactionTypeModel, merchantSetting) {
    return SetTransactionBaseModelList(transactionTypeModel, merchantSetting);
  },
  CreateTransactionJournalBaseModel(transactionTypeModel, allocationList) {
    return SetTransactionJournalBaseModelList(transactionTypeModel, allocationList);
  },
  ConvertToTransactionBaseModel(
    transactionImportList,
    transactionTypeModel,
    pageSize,
    contactList,
    productList,
    accountList,
    bankAccountList,
    merchantSetting,
    allocationItemList
  ) {
    return GetTransactionBaseModelList(
      transactionImportList,
      transactionTypeModel,
      pageSize,
      contactList,
      productList,
      accountList,
      bankAccountList,
      merchantSetting,
      allocationItemList
    );
  },
  ConvertToTransactionReceiptFromInvoiceBaseModel(
    transactionImportList,
    transactionTypeModel,
    pageSize,
    contactList,
    productList,
    accountList,
    bankAccountList,
    invoiceList,
    merchantSetting,
    importTransactionType
  ) {
    return GetTransactionReceiptFromInvoiceBaseModelList(
      transactionImportList,
      transactionTypeModel,
      pageSize,
      contactList,
      productList,
      accountList,
      bankAccountList,
      invoiceList,
      merchantSetting,
      importTransactionType
    );
  },
  ConvertToTransactionJournalBaseModel(
    transactionImportList,
    pageSize,
    contactList,
    accountList,
    bankAccountList,
    productList,
    chequeList,
    allocationItemList
  ) {
    return GetTransactionJournalBaseModelList(
      transactionImportList,
      pageSize,
      contactList,
      accountList,
      bankAccountList,
      productList,
      chequeList,
      allocationItemList
    );
  },
  ConvertToTransactionBaseModelByApplyAll(
    transactionBaseList,
    transactionTypeModel,
    applyAllTemplate,
    bankAccountList,
    merchantSetting,
    contactList
  ) {
    return GetTransactionBaseModelListByApplyAll(
      transactionBaseList,
      transactionTypeModel,
      applyAllTemplate,
      bankAccountList,
      merchantSetting,
      contactList
    );
  },
  ConvertToTransactionBaseModelByAddedFinance(importTransactionItem, bankAccountList, selectedBankAccountId) {
    return GetTransactionBaseModelByByAddedFinance(importTransactionItem, bankAccountList, selectedBankAccountId);
  },
  ConvertToTransactionImportMode(transactionBaseList, transactionTypeModel, importTransactionType) {
    return GetTransactionCreateModelList(transactionBaseList, transactionTypeModel, importTransactionType);
  },
  ConvertToTransactionImportFromReferenceMode(transactionBaseList, transactionTypeModel, importTransactionType) {
    return GetTransactionCreateFromReferenceModelList(transactionBaseList, transactionTypeModel, importTransactionType);
  },
  ConvertToTransactionImportJournalMode(transactionBaseList) {
    return GetTransactionCreateJournalModelList(transactionBaseList);
  },
  OnChangeImportTransaction(transactionBase, transactionTypeModel) {
    OnChangeImportTransaction(transactionBase, transactionTypeModel);
  },
  OnChangeImportJournal(journalBase) {
    OnChangeImportJournal(journalBase);
  },
  CreateImportTemplateTransactionHeader(transactionTypeModel, isAFPPackage) {
    switch (transactionTypeModel.transactionType) {
      case Enums.TransactionType.Quotation:
        if (transactionTypeModel.financeType == Enums.FinanceType.InFlow) {
          return SetImportTemplateQuotationHeader(isAFPPackage);
        } else if (transactionTypeModel.financeType == Enums.FinanceType.OutFlow) {
          return SetImportTemplatePurchaseOrderHeader(isAFPPackage);
        }
        break;
      case Enums.TransactionType.Invoice:
        if (transactionTypeModel.financeType == Enums.FinanceType.InFlow) {
          return SetImportTemplateInvoiceHeader(isAFPPackage);
        } else if (transactionTypeModel.financeType == Enums.FinanceType.OutFlow) {
          if (transactionTypeModel.expenseType == Enums.ExpenseType.Expense) {
            return SetImportTemplateExpenseHeader(isAFPPackage);
          } else if (transactionTypeModel.expenseType == Enums.ExpenseType.PurchaseInventory) {
            return SetImportTemplatePurchaseInventoryHeader(isAFPPackage);
          }
        }
        break;
      case Enums.TransactionType.Receipt:
        return SetImportTemplateReceiptHeader(isAFPPackage);
    }
  },
  CreateImportReferenceTemplateTransactionHeader(importTransactionType) {
    switch (importTransactionType) {
      case Enums.ImportTransactionType.ReceiptFromInvoice:
        return SetImportReferenceTemplateReceiptHeader();
    }
  },
  CreateImportTemplateJournalTransactionHeader() {
    return SetImportTemplateJournalHeader();
  },
  SelectedContact(contact, itemContact) {
    return SelectedContact(contact, itemContact);
  },
  SelectedProductTransaction(transactionItem, itemProduct, transactionType, financeType, taxStatus) {
    return SelectedProductTransaction(transactionItem, itemProduct, transactionType, financeType, taxStatus);
  },
  SelectedProduct(product, itemProduct) {
    return SelectedProduct(product, itemProduct);
  },
  SelectedAssetTemplateTransaction(transactionItem, itemAssetTemplate) {
    return SelectedAssetTemplateTransaction(transactionItem, itemAssetTemplate);
  },
  SelectedAssetTemplate(assetTemplate, itemAssetTemplate) {
    return SelectedAssetTemplate(assetTemplate, itemAssetTemplate);
  },
  SelectedAsset(transactionItem, itemAsset) {
    return SelectedAsset(transactionItem, itemAsset);
  },
  SelectedAccount(transactionItem, itemAccount, transactionType, financeType) {
    return SelectedAccount(transactionItem, itemAccount, transactionType, financeType);
  },
  SelectTransactionReferenceDocumentPayment(
    _paymentTransactionDocument,
    itemPaymentTransactionDocument,
    paymentInOutFlowType
  ) {
    return SelectTransactionReferenceDocumentPayment(
      _paymentTransactionDocument,
      itemPaymentTransactionDocument,
      paymentInOutFlowType
    );
  },
  SelectedBankAccount(bankAccount, itemBankAccount) {
    return SelectedBankAccount(bankAccount, itemBankAccount);
  },
  SelectedInvoiceReference(invoiceRef, itemInvoiceRef, transaction, contactList, canCreateTaxInvoiceNotVat) {
    return SelectedInvoiceReference(invoiceRef, itemInvoiceRef, transaction, contactList, canCreateTaxInvoiceNotVat);
  },
  SetPageNo(transactionBaseList, pageSize) {
    return SetPageNo(transactionBaseList, pageSize);
  },
  SetPageNoImportJournal(journalBaseList, pageSize) {
    return SetPageNoImportJournal(journalBaseList, pageSize);
  },
  SetImportTemplateProductHeader(productType, actionType, isActiveSkuShopee, isActiveSkuLazada, isActiveSkuTikTok) {
    return SetImportTemplateProductHeader(
      productType,
      actionType,
      isActiveSkuShopee,
      isActiveSkuLazada,
      isActiveSkuTikTok
    );
  },
  SetImportTemplateContactHeader() {
    return SetImportTemplateContactHeader();
  },
  SetImportTemplateContactSubjectHeader() {
    return SetImportTemplateContactSubjectHeader();
  },
  SetImportTemplateServiceHeader() {
    return SetImportTemplateServiceHeader();
  },
  GetImportSummaryDefault() {
    return {
      sumProductItemTotal: 0,
      sumItemPreVatTotal: 0,
      sumItemVatTotal: 0,
      sumItemNetTotal: 0,
      sumItemWhtValueTotal: 0,
      sumPaymentWhtNetAmount: 0,
      sumPaymentwhtTotal: 0,
    };
  },
  SetImportSummary(importTransactionBaseList, importSummaryState) {
    let sumProductItemTotal = 0;
    let sumItemPreVatTotal = 0;
    let sumItemNetTotal = 0;
    let sumItemWhtValueTotal = 0;
    let sumPaymentWhtNetAmount = 0;
    let sumPaymentwhtTotal = 0;
    let sumItemVatTotal = 0;
    if (importTransactionBaseList && importTransactionBaseList.length > 0) {
      importTransactionBaseList.forEach((transaction) => {
        if (transaction) {
          sumProductItemTotal += transaction.transactionItemList.length;
          transaction.transactionItemList.forEach((transactionItem) => {
            sumItemPreVatTotal += transactionItem.itemPreVatTotal.ToNumber();
            sumItemVatTotal += transactionItem.itemVatTotal.ToNumber();
            sumItemNetTotal += transactionItem.itemNetTotal.ToNumber();
            if (transactionItem.itemWht.value) {
              sumItemWhtValueTotal += transactionItem.itemWht.value.ToNumber();
            }
          });
        }
        sumPaymentWhtNetAmount += transaction.transactionSummary.paymentWht.paymentNetAmount.ToNumber();
        sumPaymentwhtTotal += transaction.transactionSummary.paymentWht.whtTotal.ToNumber();
      });
    }
    importSummaryState = {
      sumProductItemTotal: sumProductItemTotal,
      sumItemPreVatTotal: sumItemPreVatTotal,
      sumItemVatTotal: sumItemVatTotal,
      sumItemNetTotal: sumItemNetTotal,
      sumItemWhtValueTotal: sumItemWhtValueTotal,
      sumPaymentWhtNetAmount: sumPaymentWhtNetAmount,
      sumPaymentwhtTotal: sumPaymentwhtTotal,
    };
    return importSummaryState;
  },
  GetAllocationItemList(getAllocationItemList, allocationList) {
    let allocationItemList = [];
    allocationItemList.push({ id: 0, name: i18n.t("Not_specified"), textForSearch: i18n.t("Not_specified") });
    if (getAllocationItemList && getAllocationItemList.length > 0) {
      getAllocationItemList.forEach((allocation) => {
        if (allocation.allocationItemList && allocation.allocationItemList.length > 0) {
          const allocationTemplate = allocationList.find((x) => x.allocation.id === allocation.allocationId);
          allocation.allocationItemList.forEach((item, index) => {
            if (!item.isArchived) {
              if (index === 0) {
                allocationItemList.push({
                  title: true,
                  id: allocation.allocationId,
                  name: allocationTemplate ? allocationTemplate.allocation.name : "",
                  $isDisabled: true,
                  textForSearch: "",
                });
              }
              let allocationItem = shareHelper.NewObject(item);
              allocationItem.percent = "100%";
              allocationItem.valueType = Enums.AllocationValueType.Percent;
              allocationItem.textForSearch = `${allocationItem.name} ${allocationItem.number}`;
              allocationItemList.push(allocationItem);
            }
          });
        }
      });
    }
    return allocationItemList;
  },
  GetObjectDataListForJournal(transactionList, accountList) {
    return GetObjectDataListForJournal(transactionList, accountList);
  },
  GetObjectDataListForTransaction(transactionList) {
    return GetObjectDataListForTransaction(transactionList);
  },
  GetObjectDataListForReceiptFromInvoice(transactionList, invoiceList) {
    return GetObjectDataListForReceiptFromInvoice(transactionList, invoiceList);
  },
  async GetContactListForImport(objectForAutoComplete) {
    if (objectForAutoComplete.contactIdList && objectForAutoComplete.contactIdList.length > 0) {
      await store.dispatch("DoGetContactByContactIdList", objectForAutoComplete.contactIdList);
    }
    if (objectForAutoComplete.contactCodeList && objectForAutoComplete.contactCodeList.length > 0) {
      await store.dispatch("DoGetContactByContactCodeList", objectForAutoComplete.contactCodeList);
    }
    if (objectForAutoComplete.contactTaxIdList && objectForAutoComplete.contactTaxIdList.length > 0) {
      await store.dispatch("DoGetContactByContactTaxIdList", objectForAutoComplete.contactTaxIdList);
    }
    let contactList = store.getters.GetContactModelList;
    contactList = contactList.filter((x) => !x.isArchived && !x.isDeleted);
    return new Promise((resolve) => {
      resolve(contactList);
    });
  },
  async GetProductListForImport(objectForAutoComplete) {
    if (objectForAutoComplete.productIdList && objectForAutoComplete.productIdList.length > 0) {
      await store.dispatch("DoGetProductTemplateByProductIdList", objectForAutoComplete.productIdList);
    }
    if (objectForAutoComplete.productCodeList && objectForAutoComplete.productCodeList.length > 0) {
      await store.dispatch("DoGetProductTemplateByProductCodeList", objectForAutoComplete.productCodeList);
    }
    let productList = store.getters.GetProductTemplateModelList;
    productList = productList.filter((x) => !x.isArchived && !x.isDeleted);
    return new Promise((resolve) => {
      resolve(productList);
    });
  },
  async GetChequeListForImport(objectForAutoComplete) {
    if (objectForAutoComplete.chequeIdList && objectForAutoComplete.chequeIdList.length > 0) {
      await store.dispatch("DoGetChequeByIdList", objectForAutoComplete.chequeIdList);
    }
    if (objectForAutoComplete.chequeCodeList && objectForAutoComplete.chequeCodeList.length > 0) {
      await store.dispatch("DoGetChequeByCodeList", objectForAutoComplete.chequeCodeList);
    }
    let chequeList = store.getters.GetChequeModelList;
    chequeList = chequeList.filter((x) => !x.isArchived && !x.isDeleted);
    return new Promise((resolve) => {
      resolve(chequeList);
    });
  },
  GetCreateContactListInputFromImportContactList(importContactList) {
    return GetCreateContactListInputFromImportContactList(importContactList);
  },
  GetEditContactListInputFromImportContactList(importContactList, contactDetailListMap) {
    return GetEditContactListInputFromImportContactList(importContactList, contactDetailListMap);
  },
};
